<template>
  <div class="page flex-col">
    <div class="group_1 flex-col">
      <img
        class="image_1"
        referrerpolicy="no-referrer"
        src="../assets/header.png"
      />
      <div class="text-wrapper_01 flex-row justify-between">
        <span class="text_01">{{ y1 }}</span>
        <span class="text_01">{{ y2 }}</span>
      </div>

      <div class="group_2 flex-col">
        <div class="box_1 flex-row">
          <div class="group_3 flex-col">
            <div class="section_1 flex-row">
              <img
                class="thumbnail_1"
                referrerpolicy="no-referrer"
                src="@/assets/point.png"
              />
              <span class="text_1">任务启动时间</span>
              <span class="text_2" style="margin-left:50px">{{ startTime }}</span>
            </div>
            <div class="section_1 flex-row" style="margin-top:20px">
              <img
                class="thumbnail_1"
                referrerpolicy="no-referrer"
                src="@/assets/point.png"
              />
              <span class="text_1">任务用时</span>
              <span class="text_2">{{ duration }}</span>
            </div>
            <!-- <span class="text_3">用时00小时00分钟00秒</span> -->
            <div class="section_2 flex-row">
              <div class="box_2 flex-col"></div>
              <span class="text_4">设备自检状态</span>
              <img
                v-if="robotStatus == 0"
                class="image_2"
                referrerpolicy="no-referrer"
                src="@/assets/gou.png"
              />
              <img
                v-if="robotStatus == 1"
                class="label_1"
                referrerpolicy="no-referrer"
                src="@/assets/wen.png"
              />
              <img
                v-if="robotStatus == 2"
                class="image_3"
                referrerpolicy="no-referrer"
                src="@/assets/tan.png"
              />
            </div>
            <div class="section_3 flex-row">
              <div class="group_4 flex-col"></div>
              <span class="text_5">未巡车位数</span>
              <!-- <div class="group_5 flex-col justify-center">
                <div class="box_3 flex-col">
                  <div class="group_6 flex-col"></div>
                </div>
              </div> -->

              <el-progress
                :percentage="parseFloat(percentageUnfinished)"
                style="width: 200px; margin: 5px 0 0 10px"
                text-color="#00FFF6"
                color="#00FFF6"
                :stroke-width="12"
                :show-text="false"
                define-back-color="#165B94"
              ></el-progress>
            </div>
            <span class="text_6">{{ percentageUnfinished }}%</span>
            <div class="section_4 flex-row">
              <div class="block_1 flex-col"></div>
              <span class="text_7">乱停乱放车辆数</span>
              <span class="text_8">{{ illegalParkings }}</span>
            </div>
            <router-link :to="{ name: 'view12', query: { robotId: this.robotId } }">
              <div class="text-wrapper_1 flex-col">
                <span class="text_9">查看巡场报告</span>
              </div>
            </router-link>
          </div>
          <div class="group_7 flex-col justify-between">
            <img src="../assets/yibiao.png" alt=""/>
            <div id="charts2" class="echarts2"></div>
            <div class="yis">移速</div>
          </div>
          <div>
            <img src="../assets/yibiao.png" alt="" class="image_5"/>
            <div id="charts3" class="echarts3"></div>
            <div class="wangs">网速</div>
          </div>
          <div class="wanc">
            <el-progress
              type="circle"
              :percentage="parseFloat(percentagejindu)"
              class="wancheng"
              :width="110"
              :stroke-width="10"
              color="#00FFF6"
              :text-inside="true"
            ></el-progress>

            <div class="ku2">
              <div class="ku2_c1">{{ percentagejindu }}%</div>
              <div class="ku2_c2">任务完成度</div>
            </div>
          </div>
          <div class="image-wrapper_1">
            <img
              class="image_6"
              referrerpolicy="no-referrer"
              src="@/assets/backLine.png"
            />
            <el-progress
              type="circle"
              :percentage="parseFloat(percentagedianchi)"
              class="dianchi"
              :width="110"
              :stroke-width="10"
              color="#00FFF6"
              :text-inside="true"
            ></el-progress>
            <div class="ku1">
              <div class="ku_c1">{{ percentagedianchi }}%</div>
              <div class="ku_c2">剩余电量</div>
            </div>
          </div>

          <div class="image_7">
            <el-image
              v-show="currentIndex === 0"
              :src="images[0]"
              class="image_07">
            </el-image>
            <el-image
              v-show="currentIndex === 1"
              :src="images[1]"
              class="image_07">
            </el-image>
            <el-image
              v-show="currentIndex === 2"
              :src="images[2]"
              class="image_07">
            </el-image>
            <el-image
              v-show="currentIndex === 3"
              :src="images[3]"
              class="image_07">
            </el-image>
            <!--            <el-image :src="images[currentIndex]" class="image_07">-->
            <!--            <el-image src="http://bz.njrentong.com/robot.gif" class="image_07">-->
            <!--              <div slot="error" class="image-slot">-->
            <!--                <i class="el-icon-picture-outline"></i>-->
            <!--              </div>-->
            <!--            </el-image>-->
          </div>

          <div class="group_8 flex-col"></div>
          <div class="text-wrapper_3 flex-col justify-between">
            <span class="text_11 shouzhi" @click="stopRobot">结束</span> <span class="text_12 shouzhi"
                                                                               @click="startRobot">启动</span>
            <span class="text_13 shouzhi" @click="pauseRobot">暂停</span> <span class="text_14 shouzhi"
                                                                                @click="resumetRobot">继续</span>
          </div>
          <div class="group_9 flex-col justify-between">
            <div class="text-wrapper_4 flex-col" @click="goHome">
              <span class="text_15 shouzhi">回桩</span>
            </div>
            <!--            <router-link :to="{ name: 'view11', query: { robotId: this.robotId } }">-->
            <!--              <div class="box_4 flex-col">-->
            <!--                <div class="text-wrapper_5 flex-col">-->
            <!--                  <span class="text_16 shouzhi">切换手动</span>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </router-link>-->
            <div class="box_4 flex-col" @click="showConfirmDialog = true">
              <div class="text-wrapper_5 flex-col">
                <span class="text_16 shouzhi">切换手动</span>
              </div>
            </div>
            <div class="text-wrapper_6 flex-col">
              <span class="text_17">累计巡逻</span>
              <!-- <span class="text_18">4888千米</span> -->
              <div class="oneline">
                <div class="centerContenttxt2">
                  {{ parseInt(totalDistance) }}
                  <!--                  <animate-number-->
                  <!--                    from="0"-->
                  <!--                    :to="totalDistance"-->
                  <!--                    :key="totalDistance"-->
                  <!--                    duration="100"-->
                  <!--                    easing="easeOutQuad"-->
                  <!--                  ></animate-number>-->
                </div>
                <div class="centerContenttxt3">千米</div>
              </div>
              <!-- <span class="text_19">988小时</span> -->
              <div class="oneline">
                <div class="centerContenttxt2">
                  {{ totalDuration }}
                  <!--                  <animate-number-->
                  <!--                    from="0"-->
                  <!--                    :to="totalDuration"-->
                  <!--                    :key="totalDuration"-->
                  <!--                    duration="100"-->
                  <!--                    easing="easeOutQuad"-->
                  <!--                  ></animate-number>-->
                </div>
                <div class="centerContenttxt3">小时</div>
              </div>
            </div>
          </div>

          <div class="group_10 flex-col">
            <div class="box_5 flex-row">
              <!--              <img-->
              <!--                class="label_2"-->
              <!--                referrerpolicy="no-referrer"-->
              <!--                src="https://lanhu.oss-cn-beijing.aliyuncs.com/psues86lgzdvem0uupqy0cufmtp4qgyvbu81fd0c89-9b22-4eac-93be-68a57e493601"-->
              <!--              />-->
              <dv-scroll-board
                :config="config2"
                class="bottomContent3txt2tablev3"
                @click="openDia"
              />
            </div>
            <dv-scroll-board :config="config"
                             class="left2center_col3table"/>
            <!-- <div class="text-wrapper_7 flex-row">
              <span class="text_24">序号</span>
              <span class="text_25">任务名称</span>
              <span class="text_26">计划任务时间</span>
            </div> -->
            <!-- <div class="text-wrapper_8 flex-row">
              <span class="text_27">1</span> <span class="text_28">充电</span>
              <span class="text_29">15分钟结束</span>
            </div>
            <div class="text-wrapper_9 flex-row">
              <span class="text_30">2</span>
              <span class="text_31">跟踪车位</span>
              <span class="text_32">15分钟后</span>
            </div>
            <div class="text-wrapper_10 flex-row">
              <span class="text_33">3</span> <span class="text_34">巡检</span>
              <span class="text_35">22分钟后</span>
            </div>
            <div class="text-wrapper_11 flex-row">
              <span class="text_36">4</span> <span class="text_37">充电</span>
              <span class="text_38">50分钟后</span>
            </div>
            <div class="text-wrapper_12 flex-row">
              <span class="text_39">5</span> <span class="text_40">巡检</span>
              <span class="text_41">1小时20分钟后</span>
            </div> -->
          </div>

          <!-- <div @click="dakai" class="text-wrapper_4 flex-col gogo">
              <div @click="dakai2"  class="text_155">车位管理</div>
            </div>
        <div @click="dakai2" class="text-wrapper_4 flex-col gogo2">
              <div @click="dakai"  class="text_155">收费标准</div>
            </div> -->
          <div class="group_11 flex-col"></div>
          <div class="group_12 flex-col"></div>
          <div class="group_13 flex-col"></div>
          <img
            class="image_8"
            referrerpolicy="no-referrer"
            src="@/assets/pointLine.png"
            v-if="robotState == 0"
          />
          <img
            class="image_83"
            referrerpolicy="no-referrer"
            src="@/assets/pointLine.png"
            v-if="robotState == 1"
          />
          <img
            class="image_84"
            referrerpolicy="no-referrer"
            src="@/assets/pointLine.png"
            v-if="robotState == 2"
          />
          <img
            class="image_82"
            referrerpolicy="no-referrer"
            src="@/assets/pointLine.png"
            v-if="robotState == 3"
          />
        </div>

        <el-dialog
          title="确认切换"
          :visible.sync="showConfirmDialog"
          :close-on-click-modal="false"
          :close-on-press-escape="true"
          width="30%"
        >
          <div class="dialog-content">
            <p>您确定要切换到手动模式吗？切换后将由手动控制设备运行。</p>
          </div>
          <span slot="footer" class="dialog-footer">
        <el-button @click="showConfirmDialog = false">取消</el-button>
        <el-button type="primary" class="confirm-btn" @click="handleConfirmSwitch">确认</el-button>
      </span>
        </el-dialog>


        <div class="box_6 flex-row justify-between">
          <div class="block_2 flex-col">
            <div class="box_7 flex-row">
              <!-- 车位占用（绿色小车） -->
              <svg
                t="1755651269146"
                class="thumbnail_2"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="8874"
                style="width: 36px; height: 36px; transform: rotate(90deg)  translateX(-6px) translateY(-8px); transform-origin: center;"
              >
                <path
                  d="M231.982487 0.463458m199.477895-0.438675l19.231328-0.042292q199.477895-0.438676 199.91657 199.039219l1.37423 624.900328q0.438676 199.477895-199.039219 199.91657l-19.231328 0.042292q-199.477895 0.438676-199.91657-199.039219l-1.37423-624.900328q-0.438676-199.477895 199.039219-199.91657Z"
                  fill="#6BB92D" p-id="8875"
                ></path>
                <path
                  d="M278.793466 260.04778s164.975028-120.808856 326.81553-0.707036l-30.096158 146.709936a356.298925 356.298925 0 0 0-270.252664-1.838293zM312.471939 721.435798s142.750535 35.422495 261.461852-0.565628l0.377086 173.035236S430.711899 980.752975 312.849025 894.494603z"
                  fill="#383001" p-id="8876"
                ></path>
                <path
                  d="M651.330647 278.713526l35.681742 30.567516 0.023568 14.423531-35.634606-11.336141-0.070704-33.654906zM233.142519 279.632673L197.602184 310.365164l0.023568 14.399963 35.58747-11.477548-0.070703-33.654906z"
                  fill="#DBB61B" p-id="8877"
                ></path>
                <path
                  d="M233.189654 308.833253s43.364865 37.732146 43.553408 124.273332l0.707036 317.223411-28.917766-28.752791-0.77774-360.517572zM651.401351 307.890538s-43.176322 37.944256-42.987779 124.485443l0.707036 317.223411 28.75279-28.894197-0.777739-360.494005z"
                  fill="#383001" p-id="8878"
                ></path>
              </svg>
              <span class="text_42">正常停放</span>
              <svg
                class="thumbnail_2"
                viewBox="0 0 40 40"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                style="width: 36px; height: 36px;"
              >
                <rect
                  x="20"
                  y="0"
                  width="20"
                  height="20"
                  fill="#D52019"
                  stroke="#FFFFFF"
                  stroke-width="1"
                />
              </svg>
              <span class="text_44">过道违停</span>

              <!-- 异常车辆（黄色小车） -->
              <svg
                t="1755651269146"
                class="thumbnail_2"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="8874"
                style="width: 36px; height: 36px; transform: rotate(90deg)  translateX(-6px) translateY(-8px); transform-origin: center;"
              >
                <path
                d="M231.982487 0.463458m199.477895-0.438675l19.231328-0.042292q199.477895-0.438676 199.91657 199.039219l1.37423 624.900328q0.438676 199.477895-199.039219 199.91657l-19.231328 0.042292q-199.477895 0.438676-199.91657-199.039219l-1.37423-624.900328q-0.438676-199.477895 199.039219-199.91657Z"
                fill="#E76C13" p-id="8875"
              ></path>
                <path
                  d="M278.793466 260.04778s164.975028-120.808856 326.81553-0.707036l-30.096158 146.709936a356.298925 356.298925 0 0 0-270.252664-1.838293zM312.471939 721.435798s142.750535 35.422495 261.461852-0.565628l0.377086 173.035236S430.711899 980.752975 312.849025 894.494603z"
                  fill="#383001" p-id="8876"
                ></path>
                <path
                  d="M651.330647 278.713526l35.681742 30.567516 0.023568 14.423531-35.634606-11.336141-0.070704-33.654906zM233.142519 279.632673L197.602184 310.365164l0.023568 14.399963 35.58747-11.477548-0.070703-33.654906z"
                  fill="#DBB61B" p-id="8877"
                ></path>
                <path
                  d="M233.189654 308.833253s43.364865 37.732146 43.553408 124.273332l0.707036 317.223411-28.917766-28.752791-0.77774-360.517572zM651.401351 307.890538s-43.176322 37.944256-42.987779 124.485443l0.707036 317.223411 28.75279-28.894197-0.777739-360.494005z"
                  fill="#383001" p-id="8878"
                ></path>
              </svg>
              <span class="text_44">占用车位</span>
<!--              <div class="group_15 flex-col">-->
<!--                <div class="text-wrapper_14 flex-col">-->
<!--                  <a href="https://smartparking.njrentong.com/robot/equipment/Illegal/index" class="text_45"-->
<!--                     target="_blank">-->
<!--                    异常处理-->
<!--                  </a>-->
<!--                </div>-->
<!--              </div>-->

              <!-- ===================== 新增：过道违停（红色小车） ===================== -->

              <div class="group_15 flex-col">
                <div class="text-wrapper_14 flex-col">
                  <a href="https://smartparking.njrentong.com/robot/equipment/Illegal/index" class="text_45"
                     target="_blank">
                    违停处理
                  </a>
                </div>
              </div>
              <!-- ==================================================================== -->

              <!-- 乱停乱放（橙色小车） -->
              <svg
                t="1755651269146"
                class="thumbnail_2"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="8874"
                style="width: 36px; height: 36px; transform: rotate(90deg)  translateX(-6px) translateY(-8px); transform-origin: center;"
              >
                <path
                  d="M231.982487 0.463458m199.477895-0.438675l19.231328-0.042292q199.477895-0.438676 199.91657 199.039219l1.37423 624.900328q0.438676 199.477895-199.039219 199.91657l-19.231328 0.042292q-199.477895 0.438676-199.91657-199.039219l-1.37423-624.900328q-0.438676-199.477895 199.039219-199.91657Z"
                  fill="#FCEF2E" p-id="8875"
                ></path>
                <path
                  d="M278.793466 260.04778s164.975028-120.808856 326.81553-0.707036l-30.096158 146.709936a356.298925 356.298925 0 0 0-270.252664-1.838293zM312.471939 721.435798s142.750535 35.422495 261.461852-0.565628l0.377086 173.035236S430.711899 980.752975 312.849025 894.494603z"
                  fill="#383001" p-id="8876"
                ></path>
                <path
                  d="M651.330647 278.713526l35.681742 30.567516 0.023568 14.423531-35.634606-11.336141-0.070704-33.654906zM233.142519 279.632673L197.602184 310.365164l0.023568 14.399963 35.58747-11.477548-0.070703-33.654906z"
                  fill="#DBB61B" p-id="8877"
                ></path>
                <path
                  d="M233.189654 308.833253s43.364865 37.732146 43.553408 124.273332l0.707036 317.223411-28.917766-28.752791-0.77774-360.517572zM651.401351 307.890538s-43.176322 37.944256-42.987779 124.485443l0.707036 317.223411 28.75279-28.894197-0.777739-360.494005z"
                  fill="#383001" p-id="8878"
                ></path>

              </svg>
              <span class="text_46">异常车辆</span>
              <div class="group_15 flex-col">
                <div class="text-wrapper_14 flex-col">
                  <a href="https://smartparking.njrentong.com/park/park/abnormal" class="text_47"
                     target="_blank">
                    人工处理
                  </a>
                </div>
              </div>
            </div>
            <!--            <div class="box_8 flex-col">-->
            <!--              <el-image class="topContentimg" :src="imgUrl"></el-image>-->
            <!--              &lt;!&ndash; <img class="topContentimg" src="../assets/wen.jpg"> &ndash;&gt;-->
            <!--            </div>-->
            <!--            medo-->
            <div class="svg-wrapper" ref="wrapper" @wheel.prevent="handleWheel" @mousedown="startDrag"
                 @mousemove="drag"
                 @mouseup="endDrag"
                 @mouseleave="endDrag">
              <!-- 带缩放的SVG容器 -->
              <div
                class="svg-container"
                :style="{ transform: `scale(${scale}) translate(${offsetX}px, ${offsetY}px)`, transformOrigin: 'top left' }"
              >
                <svg ref="svg" id="drawing-area"
                     xmlns="http://www.w3.org/2000/svg"
                     width="100%"
                     height="100%"
                >
                  <rect id="backRect" width="100%" :height="imgHeight" fill="none" stroke="none" stroke-width="2"/>

                  <image id="backImage" ref="image" :href=mapImageSrc height="100%"/>

                  <foreignObject v-if="showLeiDa"
                                 :x="oRobotX - 80"
                                 :y="oRobotY - 80"
                                 :width="80 * 2"
                                 :height="80 * 2">
                    <div xmlns="http://www.w3.org/1999/xhtml"
                         :style=
                           "`width: ${80 * 2}px;
                           height: ${80 * 2}px;
                  border-radius: 50%;
                  background: conic-gradient(from 0deg,rgba(0, 200, 255, 0.0) 0%,rgba(0, 200, 255, 0.1) 70%,rgba(0, 200, 255, 0.2) 90%,rgba(0, 200, 255, 1) 100%);
                  transform: rotate(${this.currentAngle}deg);
                  transform-origin: center;
                  opacity: 0.9;`">
                    </div>
                  </foreignObject>
                  <svg v-if="showLeiDa"
                       :x="oRobotX - 80"
                       :y="oRobotY - 80"
                       :width="160"
                       :height="160"
                       style="position: absolute; pointer-events: none;">
                    <defs>
                      <linearGradient id="fadeWhite" x1="0" y1="-78" x2="0" y2="0" gradientUnits="userSpaceOnUse">
                        <stop offset="0%" stop-color="#FFFFFF" stop-opacity="1"/>
                        <stop offset="100%" stop-color="#FFFFFF" stop-opacity="0"/>
                      </linearGradient>
                    </defs>
                    <g transform="translate(80, 80)">
                      <circle r="78" stroke="rgba(255, 255, 255, 0.3)" stroke-width="0.5" fill="none"/>
                      <g v-for="i in 40" :key="i">
                        <line
                          :x1="0"
                          :y1="-76"
                          :x2="0"
                          :y2="-72"
                          stroke="rgba(255, 255, 255, 0.4)"
                          stroke-width="1"
                          :transform="`rotate(${i * 9})`"/>
                      </g>

                      <g v-for="i in 8" :key="'divider-' + i">
                        <line
                          :x1="0"
                          :y1="-78"
                          :x2="0"
                          :y2="0"
                          stroke="url(#fadeWhite)"
                          stroke-width="1"
                          :transform="`rotate(${i * 45})`"/>
                      </g>
                    </g>
                  </svg>


                  <g v-for="(rect, index) in temporaryParking" :key="'temp-' + index + '-' + rect[0]">
                    <!-- 原长方形polygon -->
                    <polygon
                      :points="rect"
                      fill="transparent"
                      stroke="transparent"
                      stroke-width="0.1"
                    />

                    <svg
                      t="1755651269146"
                      class="icon car-icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="8874"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      :width="getCarSize(rect)"
                      :height="getCarSize(rect)"
                      :x="getCarPosition(rect).x"
                      :y="getCarPosition(rect).y"
                      :transform="`rotate(${getCarRotation(rect)}, ${getCarPosition(rect).x + getCarSize(rect)/2}, ${getCarPosition(rect).y + getCarSize(rect)/2})`"
                    >
                      <path
                        d="M231.982487 0.463458m199.477895-0.438675l19.231328-0.042292q199.477895-0.438676 199.91657 199.039219l1.37423 624.900328q0.438676 199.477895-199.039219 199.91657l-19.231328 0.042292q-199.477895 0.438676-199.91657-199.039219l-1.37423-624.900328q-0.438676-199.477895 199.039219-199.91657Z"
                        fill="#6BB92D" p-id="8875"
                      ></path>
                      <path
                        d="M278.793466 260.04778s164.975028-120.808856 326.81553-0.707036l-30.096158 146.709936a356.298925 356.298925 0 0 0-270.252664-1.838293zM312.471939 721.435798s142.750535 35.422495 261.461852-0.565628l0.377086 173.035236S430.711899 980.752975 312.849025 894.494603z"
                        fill="#383001" p-id="8876"
                      ></path>
                      <path
                        d="M651.330647 278.713526l35.681742 30.567516 0.023568 14.423531-35.634606-11.336141-0.070704-33.654906zM233.142519 279.632673L197.602184 310.365164l0.023568 14.399963 35.58747-11.477548-0.070703-33.654906z"
                        fill="#DBB61B" p-id="8877"
                      ></path>
                      <path
                        d="M233.189654 308.833253s43.364865 37.732146 43.553408 124.273332l0.707036 317.223411-28.917766-28.752791-0.77774-360.517572zM651.401351 307.890538s-43.176322 37.944256-42.987779 124.485443l0.707036 317.223411 28.75279-28.894197-0.777739-360.494005z"
                        fill="#383001" p-id="8878"
                      ></path>
                    </svg>
                  </g>
                  <!--                  <polygon v-for="(rect, index) in illegalParking" :key="'illegal-' + index + '-' + rect[0]"-->
                  <!--                           :points="rect"-->
                  <!--                           fill="#E76C13"-->
                  <!--                           stroke="#FFF"-->
                  <!--                           stroke-width="1.5"/>-->
                  <g v-for="(rect, index) in illegalParking" :key="'temp-' + index + '-' + rect[0]">
                    <!-- 原长方形polygon -->
                    <polygon
                      :points="rect"
                      fill="transparent"
                      stroke="transparent"
                      stroke-width="0.1"
                    />

                    <svg
                      t="1755651269146"
                      class="icon car-icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="8874"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      :width="getCarSize(rect)"
                      :height="getCarSize(rect)"
                      :x="getCarPosition(rect).x"
                      :y="getCarPosition(rect).y"
                      :transform="`rotate(${getCarRotation(rect)}, ${getCarPosition(rect).x + getCarSize(rect)/2}, ${getCarPosition(rect).y + getCarSize(rect)/2})`"
                    >
                      <path
                        d="M231.982487 0.463458m199.477895-0.438675l19.231328-0.042292q199.477895-0.438676 199.91657 199.039219l1.37423 624.900328q0.438676 199.477895-199.039219 199.91657l-19.231328 0.042292q-199.477895 0.438676-199.91657-199.039219l-1.37423-624.900328q-0.438676-199.477895 199.039219-199.91657Z"
                        fill="#E76C13" p-id="8875"
                      ></path>
                      <path
                        d="M278.793466 260.04778s164.975028-120.808856 326.81553-0.707036l-30.096158 146.709936a356.298925 356.298925 0 0 0-270.252664-1.838293zM312.471939 721.435798s142.750535 35.422495 261.461852-0.565628l0.377086 173.035236S430.711899 980.752975 312.849025 894.494603z"
                        fill="#383001" p-id="8876"
                      ></path>
                      <path
                        d="M651.330647 278.713526l35.681742 30.567516 0.023568 14.423531-35.634606-11.336141-0.070704-33.654906zM233.142519 279.632673L197.602184 310.365164l0.023568 14.399963 35.58747-11.477548-0.070703-33.654906z"
                        fill="#DBB61B" p-id="8877"
                      ></path>
                      <path
                        d="M233.189654 308.833253s43.364865 37.732146 43.553408 124.273332l0.707036 317.223411-28.917766-28.752791-0.77774-360.517572zM651.401351 307.890538s-43.176322 37.944256-42.987779 124.485443l0.707036 317.223411 28.75279-28.894197-0.777739-360.494005z"
                        fill="#383001" p-id="8878"
                      ></path>
                    </svg>
                  </g>
                  <!-- 无车位维廷 -->
                  <!-- 无车位停放车 → 4个坐标连线 + 小车图标 -->


                  <g v-for="(rect, index) in illegalNoParking" :key="'noparking-' + index + '-' + (rect.centerX || rect[0])">
                    <!-- 保留原透明polygon用于占位（可选） -->
                    <polygon
                      v-if="typeof rect !== 'object' || !rect.centerX"
                      :points="rect"
                      fill="transparent"
                      stroke="transparent"
                      stroke-width="0.1"
                    />
                    <!-- 红色小方块 -->
                    <rect
                      :x="getCenterPoint(rect).x - getBlockSize(rect)/2"
                      :y="getCenterPoint(rect).y - getBlockSize(rect)/2"
                      :width="getBlockSize(rect)"
                      :height="getBlockSize(rect)"
                      fill="#D52019"
                      stroke="#FFFFFF"
                      stroke-width="1"
                      class="illegal-block"
                    />
                  </g>


                  <polygon v-for="(rect, index) in occupationParking" :key="'occupation-' + index + '-' + rect[0]"
                           :points="rect"
                           fill="none"
                           stroke="#FCEF2E"
                           stroke-width="1.5"
                           stroke-dasharray="5,2"/>

                  <!--                  <g v-for="(rect, index) in occupationParking" :key="'temp-' + index + '-' + rect[0]">-->
                  <!--                    &lt;!&ndash; 原长方形polygon &ndash;&gt;-->
                  <!--                    <polygon-->
                  <!--                      :points="rect"-->
                  <!--                      fill="transparent"-->
                  <!--                      stroke="transparent"-->
                  <!--                      stroke-width="0.1"-->
                  <!--                    />-->

                  <!--                    <svg-->
                  <!--                      t="1755651269146"-->
                  <!--                      class="icon car-icon"-->
                  <!--                      viewBox="0 0 1024 1024"-->
                  <!--                      version="1.1"-->
                  <!--                      xmlns="http://www.w3.org/2000/svg"-->
                  <!--                      p-id="8874"-->
                  <!--                      xmlns:xlink="http://www.w3.org/1999/xlink"-->
                  <!--                      :width="getCarSize(rect)"-->
                  <!--                      :height="getCarSize(rect)"-->
                  <!--                      :x="getCarPosition(rect).x"-->
                  <!--                      :y="getCarPosition(rect).y"-->
                  <!--                      :transform="`rotate(${getCarRotation(rect)}, ${getCarPosition(rect).x + getCarSize(rect)/2}, ${getCarPosition(rect).y + getCarSize(rect)/2})`"-->
                  <!--                    >-->
                  <!--                      <path-->
                  <!--                        d="M231.982487 0.463458m199.477895-0.438675l19.231328-0.042292q199.477895-0.438676 199.91657 199.039219l1.37423 624.900328q0.438676 199.477895-199.039219 199.91657l-19.231328 0.042292q-199.477895 0.438676-199.91657-199.039219l-1.37423-624.900328q-0.438676-199.477895 199.039219-199.91657Z"-->
                  <!--                        fill="#FCEF2E" p-id="8875"-->
                  <!--                      ></path>-->
                  <!--                      <path-->
                  <!--                        d="M278.793466 260.04778s164.975028-120.808856 326.81553-0.707036l-30.096158 146.709936a356.298925 356.298925 0 0 0-270.252664-1.838293zM312.471939 721.435798s142.750535 35.422495 261.461852-0.565628l0.377086 173.035236S430.711899 980.752975 312.849025 894.494603z"-->
                  <!--                        fill="#383001" p-id="8876"-->
                  <!--                      ></path>-->
                  <!--                      <path-->
                  <!--                        d="M651.330647 278.713526l35.681742 30.567516 0.023568 14.423531-35.634606-11.336141-0.070704-33.654906zM233.142519 279.632673L197.602184 310.365164l0.023568 14.399963 35.58747-11.477548-0.070703-33.654906z"-->
                  <!--                        fill="#DBB61B" p-id="8877"-->
                  <!--                      ></path>-->
                  <!--                      <path-->
                  <!--                        d="M233.189654 308.833253s43.364865 37.732146 43.553408 124.273332l0.707036 317.223411-28.917766-28.752791-0.77774-360.517572zM651.401351 307.890538s-43.176322 37.944256-42.987779 124.485443l0.707036 317.223411 28.75279-28.894197-0.777739-360.494005z"-->
                  <!--                        fill="#383001" p-id="8878"-->
                  <!--                      ></path>-->
                  <!--                    </svg>-->
                  <!--                  </g>-->


                  <!--                  <polygon v-for="(rect, index) in fakeParking" :key="'fake-' + index + '-' + rect[0]"-->
                  <!--                           :points="rect"-->
                  <!--                           fill="#D2CBD4"-->
                  <!--                           stroke="#E87D10"-->
                  <!--                           stroke-width="1.5"-->
                  <!--                           stroke-dasharray="5,2"/>-->

                  <!--                  todo 配色 点的大小-->
                  <circle v-for="(point, index) in occupationPoints"
                          :key="'occupationPoint-' + index + '-' + point.x + '-' + point.y"
                          :cx="point.x"
                          :cy="point.y"
                          r="0.3"
                          fill="#D52019"/>
                  <!--                  <circle v-for="(point, index) in fakePoints"-->
                  <!--                          :key="'fakePoint-' + index + '-' + point.x + '-' + point.y"-->
                  <!--                          :cx="point.x"-->
                  <!--                          :cy="point.y"-->
                  <!--                          r="0.2"-->
                  <!--                          fill="#D52019"/>-->

                  <!--                  <line v-for="(point, index) in nowRadarPoint"-->
                  <!--                        :key="'nowRadarPoint-' + index + '-' + point.x + '-' + point.y"-->
                  <!--                        :x1="robotX+8" :y1="robotY+8"-->
                  <!--                        :x2="point.x" :y2="point.y"-->
                  <!--                        fill="none" stroke="#fedede" stroke-width="1"/>-->

                  <!--                  <image-->
                  <!--                    v-if="showLeiDa"-->
                  <!--                    :x="robotX-12"-->
                  <!--                    :y="robotY-12"-->
                  <!--                    width="40"-->
                  <!--                    height="40"-->
                  <!--                    :xlink:href="require('@/assets/image/lei1.png')"-->
                  <!--                  >-->
                  <!--                  </image>-->
                  <!--                  <image-->
                  <!--                    v-if="showLeiDa"-->
                  <!--                    :transform="'rotate(' + currentAngle + ' ' + oRobotX + ' ' + oRobotY + ')'"-->
                  <!--                    :x="robotX-72"-->
                  <!--                    :y="robotY-72"-->
                  <!--                    width="160"-->
                  <!--                    height="160"-->
                  <!--                    :xlink:href="require('@/assets/image/leida3.png')"-->
                  <!--                  >-->
                  <!--                  </image>-->
                  <!--                  <g :transform="'rotate(' + currentAngle + ' ' + oRobotX + ' ' + oRobotY + ')'">-->
                  <!--                    <line-->
                  <!--                      v-if="showLeiDa"-->
                  <!--                      :x1="oRobotX"-->
                  <!--                      :y1="oRobotY"-->
                  <!--                      :x2="oRobotX"-->
                  <!--                      :y2="oRobotY - 80"-->
                  <!--                      stroke="rgba(52, 255, 250, 0.6)"-->
                  <!--                      stroke-width="3"-->
                  <!--                    >-->
                  <!--                    </line>-->
                  <!--                  </g>-->
                  <polyline :points="trajectoryPoints" fill="none" stroke="#50C0E1" stroke-width="2"/>

                  <circle v-for="(point, index) in radarPoints"
                          :key="'radarPoints-' + index + '-' + point.x + '-' + point.y"
                          :cx="point.x"
                          :cy="point.y"
                          r="0.3"
                          fill="#D52019"/>

                  <circle v-for="(point, index) in shineRadarPoints"
                          v-if="showLeiDa"
                          :key="'shineRadarPoints-' + index"
                          :cx="point.x"
                          :cy="point.y"
                          r="1"
                          :fill="point.color || '#FF3B3F'"
                          class="shine-point">
                  </circle>
                  <image :x="this.robotX" :y="this.robotY" :transform="this.robotAngleStr" xlink:href="robotGo.png"
                         width="16"
                         height="16"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="block_3 flex-col">
            <div class="block_4 flex-row">
              <div class="image-text_1 flex-row justify-between">
                <img
                  class="image_9"
                  referrerpolicy="no-referrer"
                  src="https://lanhu.oss-cn-beijing.aliyuncs.com/psstqqi1267eb064q67hhfcr6hoqw8b4ki1ibfb4f07f-25b5-411b-b98c-2f727c313b74"
                />
                <span class="text-group_1">实时监控画面</span>
              </div>
              <div class="group_17 flex-row">
                <!-- <div class="image-text_2 flex-row justify-between">
                  <span class="text-group_2" >低帧率</span>
                  <img
                    class="thumbnail_19"
                    referrerpolicy="no-referrer"
                    src="https://lanhu.oss-cn-beijing.aliyuncs.com/pss9hmrvcwnm9479s8vmj4p7mls59vewp5b2979dd6-2d2a-4e1a-a10e-82a183685e34"
                  />
                </div> -->
              </div>
              <router-link :to="{ name: 'view6', query: { robotId: this.robotId } }">
                <div class="group_18 flex-col">
                  <div class="text-wrapper_16 flex-col">
                    <span class="text_48">监控详情</span>
                  </div>
                </div>
              </router-link>

            </div>


            <div class="block_5 flex-row justify-center">
              <div class="video-wrappercenter flex-col">
                <span class="video-title">{{ robotName }}前方摄像头</span> <!-- 新增文字 -->
                <div id="video-container0" style="width: 450px; height: 250px"></div>
              </div>
            </div>
            <div class="block_6 flex-row justify-between">
              <div class="video-wrapperleft flex-col">
                <span class="video-title">{{ robotName }}左后方摄像头</span> <!-- 新增文字 -->
                <div id="video-container1" style="width: 450px; height: 250px"></div>
              </div>
              <div class="video-wrapperright flex-col">
                <span class="video-title">{{ robotName }}右后方摄像头</span> <!-- 新增文字 -->
                <div id="video-container2" style="width: 450px; height: 250px"></div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>

</template>


<script>
import "video.js/dist/video-js.css";
import "videojs-flash";
// import EZUIKit from "ezuikit-js";
import EZUIKit from '@/assets/js/ezuikit';
import {get} from "@/util/axios";
import auth from "@/util/auth";

var that;
var interval2;
var interval3;
var interval4;
var interval5;
var echarts2;
var echarts3;

export default {
  data() {
    return {
      videoList: [],
      robotState: 0,
      robotId: 0,
      networkSpeed: 0, // 网络速率，单位为 KB/s
      imgUrl: "",
      startTime: "", //任务开始时间
      duration: "", //任务用时
      robotStatus: "", //状态
      percentageUnfinished: 0, //未巡车位数，百分比0到100
      illegalParkings: "", //乱停乱放车位数
      percentagejindu: 0,
      percentagedianchi: 0,
      totalDistance: 0,
      totalDuration: 0,
      showConfirmDialog: false, // 控制弹窗显示
      y1: "",
      y2: "",
      player0: null,
      player1: null,
      player2: null,
      imgHeight: 0,
      imgWidth: 0,
      mapOHeight: 0,
      mapOWeight: 0,
      mapImageSrc: "",
      robotX: 0,
      robotY: 0,
      oRobotX: 0,

      oRobotY: 0,
      trajectoryPoints: '',
      robotAngleStr: 'rotate(45, 50, 50)',
      temporaryParking: [],//临停车
      illegalParking: [],//乱停乱放
      illegalNoParking: [],//无车位停放车
      occupationParking: [],
      occupationPoints: [],
      fakeParking: [],
      mapParam:{},
      fakePoints: [],
      radarPoints: [],
      nowRadarPoint: [],
      lastRadarPoint: [],
      showLeiDa: false,
      wallList: [],
      robotName: "",
      scale: 1,
      scaleStep: 0.05,
      minScale: 0.2,
      maxScale: 5,
      offsetX: 0,
      offsetY: 0,
      isDragging: false,
      lastMouseX: 0,
      lastMouseY: 0,
      currentAngle: 0,
      rafId: null,
      sweptRadarPoints: [],
      shineRadarPoints: [],


      option2: {
        series: [
          {
            type: "gauge",
            max: 2,
            splitNumber: 2,
            itemStyle: {
              color: "#00FFF6",
              shadowColor: "rgba(0,138,255,0.45)",
              shadowBlur: 10,
              shadowOffsetX: 2,
              shadowOffsetY: 2,
            },
            progress: {
              show: true,
              width: 10,
              itemStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#5AFFA9", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#00FFF6", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            axisLine: {
              lineStyle: {
                width: 10,
                opacity: 0.2,
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              distance: 1,
              length: 10,
              lineStyle: {
                width: 1,
                color: "#00FFF6",
              },
            },
            axisLabel: {
              distance: 12,
              color: "#00FFF6",
              fontSize: 10,
            },
            anchor: {
              show: true,
              showAbove: true,
              size: 10,
              itemStyle: {
                borderWidth: 2,
              },
            },
            pointer: {
              icon: "path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z",
              length: "45%",
              width: 4,
              offsetCenter: [0, "1%"],
            },
            title: {
              show: false,
            },
            detail: {
              valueAnimation: true,
              fontSize: 80,
              offsetCenter: [0, "70%"],
              formatter: function (value) {
                return "{value|" + value.toFixed(1) + "}{unit|米/秒}";
              },
              rich: {
                value: {
                  fontSize: 15,
                  fontWeight: "bolder",
                  color: "#00FFF6",
                },
                unit: {
                  fontSize: 10,
                  color: "#00FFF6",
                  padding: [0, 0, 0, 10],
                },
              },
            },
            data: [
              {
                value: 1,
              },
            ],
          },
        ],
      },
      option3: {
        series: [
          {
            type: "gauge",
            max: 10,
            splitNumber: 2,
            itemStyle: {
              color: "#00FFF6",
              shadowColor: "rgba(0,138,255,0.45)",
              shadowBlur: 10,
              shadowOffsetX: 2,
              shadowOffsetY: 2,
            },
            progress: {
              show: true,
              width: 10,
              itemStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#5AFFA9", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#00FFF6", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            axisLine: {
              lineStyle: {
                width: 10,
                opacity: 0.2,
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              distance: 1,
              length: 10,
              lineStyle: {
                width: 1,
                color: "#00FFF6",
              },
            },
            axisLabel: {
              distance: 12,
              color: "#00FFF6",
              fontSize: 10,
            },
            anchor: {
              show: true,
              showAbove: true,
              size: 10,
              itemStyle: {
                borderWidth: 2,
              },
            },
            pointer: {
              icon: "path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z",
              length: "45%",
              width: 4,
              offsetCenter: [0, "1%"],
            },
            title: {
              show: false,
            },
            detail: {
              valueAnimation: true,
              fontSize: 80,
              offsetCenter: [0, "70%"],
              formatter: function (value) {
                return "{value|" + value.toFixed(1) + "}{unit|MB/s}";
              },
              rich: {
                value: {
                  fontSize: 15,
                  fontWeight: "bolder",
                  color: "#00FFF6",
                },
                unit: {
                  fontSize: 10,
                  color: "#00FFF6",
                  padding: [0, 0, 0, 10],
                },
              },
            },
            data: [
              {
                value: 1,
              },
            ],
          },
        ],
      },
      config: {
        header: ["任务类型", "任务时间"],
        data: [],
        align: ["center", "center"],
        columnWidth: [200, 220],
        rowNum: 3,
        headerBGC: "transparent",
        oddRowBGC: "transparent",
        evenRowBGC: "transparent",
      },
      size: 100,
      config2: {
        header: ["告警内容", "告警类型"],
        data: [],
        align: ["center", "center"],
        columnWidth: [200, 250],
        rowNum: 3,
        headerBGC: "transparent",
        oddRowBGC: "transparent",
        evenRowBGC: "transparent",
      },
      images: [
        require('@/assets/image/1.png'),
        require('@/assets/image/2.png'),
        require('@/assets/image/3.png'),
        require('@/assets/image/4.png')
      ],
      currentIndex: 0
    };
  },
  watch: {
    currentAngle(newVal, oldVal) {
      // 你可以在这里添加处理逻辑
      this.sweptRadarPoints = [];
      // 判断 nowRadarPoint 中哪些点被扫到
      if (this.showLeiDa) {
        for (const point of this.nowRadarPoint) {
          if (this.isAngleClose(point.angle, oldVal, newVal)) {
            // 添加点并设置动画
            this.startShinePoint(point);
            // 加入累积点
            this.sweptRadarPoints.push(point);
          }
        }
      }
      // const EPSILON = 0.1;
      // 过滤出 transformedPoints 中不在 this.nowRadarPoint 里的点
      // const uniqueSweptPoints = this.sweptRadarPoints
      //   .filter(sp =>
      //     !this.lastRadarPoint?.some(lp =>
      //       Math.abs(lp.x - sp.x) < EPSILON && Math.abs(lp.y - sp.y) < EPSILON
      //     ) && !sp.isNearWall // 排除掉靠近墙的点
      //   );
      const uniqueSweptPoints = this.sweptRadarPoints
        .filter(sp => !sp.isNearWall);  // 只排除靠近墙的点
      this.radarPoints.push(...uniqueSweptPoints);
      // 使用关键点渲染
      // console.log("前")
      // console.log(this.radarPoints.length);
      this.radarPoints = this.selectKeyPoints(this.radarPoints);

      // 打印当前的 radarPoints 数量，确认是否正确
      // console.log(this.radarPoints.length);
    },
    nowRadarPoint(newVal, oldVal) {
      this.lastRadarPoint = oldVal;
    }
  },
  created() {

    if (this.$route.query.robotId) {
      this.robotId = this.$route.query.robotId;
      this.getThreeMap();

    }
  },
  mounted() {



    that = this;
    interval2 = setInterval(function () {
      that.getTime();
      that.getNetspeed2();
    }, 1000);

    this.getImageSize()
    window.addEventListener('resize', this.updateImageSize)
    interval3 = setInterval(function () {
      that.resetDrawPic();
      that.getThreeMovePoint();
    }, 3000);

    interval4 = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    }, 2000);
    interval5 = setInterval(function () {
      that.getjindu();
      that.getTotalDuration();
      that.getRobotTasks();
      that.getBizSpotRecordWarnByState();
      that.getThreeSpot();
    }, 8000);

    echarts2 = this.$echarts.init(document.getElementById("charts2"));
    echarts3 = this.$echarts.init(document.getElementById("charts3"));
    that.getjindu();
    that.getTotalDuration();
    that.getRobotTasks();
    that.getBizSpotRecordWarnByState();
    this.playVideo();
    this.animate();
  },
  beforeDestroy() {
    // 在组件销毁前销毁播放器
    if (this.player0) {
      // 销毁播放器实例
      this.player0.destroy();
      // 解除播放器的引用
      this.player0 = null;
    }
    if (this.player1) {
      // 销毁播放器实例
      this.player1.destroy();
      // 解除播放器的引用
      this.player1 = null;
    }
    if (this.player2) {
      // 销毁播放器实例
      this.player2.destroy();
      // 解除播放器的引用
      this.player2 = null;
    }
    // 清除所有定时器
    if (interval2) {
      clearInterval(interval2);
      interval2 = null;
    }
    if (interval3) {
      clearInterval(interval3);
      interval3 = null;
    }
    if (interval4) {
      clearInterval(interval4);
      interval4 = null;
    }
    if (interval5) {
      clearInterval(interval5);
      interval5 = null;
    }
    window.removeEventListener('resize', this.updateImageSize)
    cancelAnimationFrame(this.rafId);
  },

  methods: {
    // selectKeyPoints(points) {
    //   const selectedPoints = [];
    //   let lastPoint = null;
    //   const DISTANCE_THRESHOLD = 5; // 最小距离，单位 px，5px为间隔限制
    //
    //   for (const point of points) {
    //     if (!lastPoint || Math.hypot(point.x - lastPoint.x, point.y - lastPoint.y) > DISTANCE_THRESHOLD) {
    //       selectedPoints.push(point);
    //       lastPoint = point;
    //     }
    //   }
    //
    //   return selectedPoints;
    // },
    getCarAngle(rect) {
      // 取车辆前两个点，计算朝向角度
      const dx = rect[2] - rect[0];
      const dy = rect[3] - rect[1];
      // 弧度转角度（SVG rotate 用角度制）
      return Math.atan2(dy, dx) * 180 / Math.PI;
    },

    selectKeyPoints(points) {
      const grid = new Map();
      const selected = [];

      const GRID_SIZE = 1;

      // 先进行网格筛选，去掉太密的点
      for (const point of points) {
        const keyX = Math.floor(point.x / GRID_SIZE);
        const keyY = Math.floor(point.y / GRID_SIZE);
        const key = `${keyX}_${keyY}`;

        if (!grid.has(key)) {
          grid.set(key, point);
        }
      }

      for (const point of grid.values()) {
        selected.push(point);
      }

      const MAX_POINTS = 2000;

      // 如果筛完还是超了3000个，再进一步稀释
      if (selected.length > MAX_POINTS) {
        const ratio = MAX_POINTS / selected.length; // 保留比例
        const finalPoints = [];

        let accumulator = 0;
        for (const point of selected) {
          accumulator += ratio;
          if (accumulator >= 1) {
            finalPoints.push(point);
            accumulator -= 1;
          }
        }

        return finalPoints;
      }

      return selected;
    },
    // processX(x, y) {
    //   let result = 0;
    //   if (this.robotId === '4' ) {
    //     //result = parseFloat(x) * 20.01223990208078 + 305;
    //     result = 1956.481 - 30.653 * parseFloat(x) - 1.484 * parseFloat(y);
    //   } else if (this.robotId === '5') {
    //     // result = 470.02 - 1.65 * parseFloat(x) + 28.37 * parseFloat(y);
    //     result = 1.3600 * parseFloat(x) + 28.0353 * parseFloat(y) + 516.9969;
    //   } else if (this.robotId === '6') {
    //     result = 32.19 * parseFloat(x) + 0.27 * parseFloat(y) + 654.13;
    //   }else if(this.robotId==='3'){
    //     result = 21.148 * parseFloat(x) -0.047* parseFloat(y) +291.99;
    //   }else if(this.robotId==='16'){
    //     result = 21.148 * parseFloat(x) -0.047* parseFloat(y) +291.99;
    //   } else if(this.robotId==='171'||this.robotId ==='176'){
    //     result = 21.148 * parseFloat(x) -0.047* parseFloat(y) +291.99;
    //   } else if(this.robotId==='172'){
    //     result = 8.7397 * parseFloat(x) + 0.0310 * parseFloat(y) + 990.1399;
    //   }else if(this.robotId==='173'){
    //     result = 8.629198 * parseFloat(x) + 0.179402 * parseFloat(y) + 1031.738509;
    //   }else if(this.robotId==='174'){
    //     result =6.482605 * parseFloat(x) + -5.315920 * parseFloat(y) + 1255.838351;
    //   }else if(this.robotId==='175'){
    //     result =  8.502007* parseFloat(x)+ 0.224816* parseFloat(y) + 1644.672657
    //   }else if(this.robotId==='179'){
    //     result =  1.531345* parseFloat(x)+-79.237351* parseFloat(y) + 5688.439004
    //   }else if(this.robotId==='180'){
    //     result = 0.010528* parseFloat(x) + 41.337585* parseFloat(y) + 5635.606116
    //   }
    //   return parseFloat(result.toFixed(1));
    // },
    // processY(x, y) {
    //   let result = 0;
    //   if ( this.robotId === '4') {
    //     //result = 1846 - parseFloat(y) * 20.00797925393976;
    //     result = -0.487 * parseFloat(x) + 26.395 * parseFloat(y) + 1213.689;
    //   } else if (this.robotId === '5') {
    //     // result = 634.01 + 21.81 * parseFloat(x) + 0.88 * parseFloat(y);
    //     result = 21.8067 * parseFloat(x) - 1.1227 * parseFloat(y) + 685.5309
    //   } else if (this.robotId === '6') {
    //     result = 0.22 * parseFloat(x) - 24.47 * parseFloat(y) + 1792.07
    //   }else if(this.robotId ==='3'){
    //     result = -1.039 * parseFloat(x) -19.654 * parseFloat(y) +1837.336
    //   }else if(this.robotId ==='171'||this.robotId ==='176'){
    //     result = -1.039 * parseFloat(x) -19.654 * parseFloat(y) +1837.336
    //   } else if(this.robotId ==='16'){
    //     result = -1.039 * parseFloat(x) -19.654 * parseFloat(y) +1837.336
    //   }else if(this.robotId ==='172') {
    //     result = 0.0188 * parseFloat(x) + -8.6130 * parseFloat(y) + 1060.6248;
    //   }else if(this.robotId ==='173') {
    //     result = 0.439786 * parseFloat(x) + -8.710597 * parseFloat(y) + 916.141851;
    //   }else if(this.robotId ==='174'){
    //     result =-5.350924 * parseFloat(x) + -6.551079 * parseFloat(y) +762.524563;
    //   }else if(this.robotId ==='175'){
    //     result =0.300449* parseFloat(x) + -8.331543* parseFloat(y) + 736.924314
    //   }else if(this.robotId==='179'){
    //     result = -79.848067* parseFloat(x) + -3.167545* parseFloat(y) + 3081.612555
    //   }else if(this.robotId==='180'){
    //     result =  41.498730* parseFloat(x)  + -0.006519* parseFloat(y) + 1445.183727
    //   }
    //   return parseFloat(result.toFixed(1));
    // },
    processX(x, y) {

      const { xa, xb, xc } = this.mapParam;
      const xVal = xa * parseFloat(x) + xb * parseFloat(y) + xc;
      return parseFloat(xVal.toFixed(1));
    },
    processY(x, y) {
      const { ya, yb, yc } = this.mapParam;
      const yVal = ya * parseFloat(x) + yb * parseFloat(y) + yc;
      return parseFloat(yVal.toFixed(1));
    },
    startShinePoint(point) {
      // 如果已经在闪烁列表中，跳过
      if (this.shineRadarPoints.some(p => Math.abs(p.x - point.x) < 0.5 && Math.abs(p.y - point.y) < 0.5)) {
        return;
      }
      const newPoint = {...point, id: Date.now() + Math.random()};
      this.shineRadarPoints.push(newPoint);

      // 1.5秒后移除点
      setTimeout(() => {
        const index = this.shineRadarPoints.findIndex(p => p.id === newPoint.id);
        if (index !== -1) {
          this.shineRadarPoints.splice(index, 1);
        }
      }, 1000);
    },
    getCenterPoint(rect) {
      // 如果是带centerX/Y的对象，直接返回
      if (typeof rect === 'object' && rect.centerX && rect.centerY) {
        return { x: rect.centerX, y: rect.centerY };
      }
      // 处理坐标字符串（格式："x1,y1 x2,y2 x3,y3 x4,y4"）
      try {
        const points = rect.split(' ').map(p => p.split(',').map(Number));
        const xArr = points.map(p => p[0]);
        const yArr = points.map(p => p[1]);
        const centerX = (Math.min(...xArr) + Math.max(...xArr)) / 2;
        const centerY = (Math.min(...yArr) + Math.max(...yArr)) / 2;
        return { x: centerX, y: centerY };
      } catch (e) {
        console.error('计算中心坐标失败:', e, rect);
        return { x: 0, y: 0 };
      }
    },
    // 新增：获取小方块尺寸（自适应）
    getBlockSize(rect) {
      // 自定义尺寸优先级最高
      if (typeof rect === 'object' && rect.blockSize) {
        return rect.blockSize;
      }
      // 自适应计算（取区域最小边的1/4，限制10-30px）
      try {
        const points = rect.split(' ').map(p => p.split(',').map(Number));
        const xArr = points.map(p => p[0]);
        const yArr = points.map(p => p[1]);
        const width = Math.max(...xArr) - Math.min(...xArr);
        const height = Math.max(...yArr) - Math.min(...yArr);
        return 6;
      } catch (e) {
        // 异常时返回默认尺寸
        return 6;
      }
    },
    getTickColor(index) {
      const angle = index;

      // 计算当前刻度和当前角度的差值
      const angleDiff = (angle - this.currentAngle + 360) % 360; // 处理负数，确保角度差为正

      if (angleDiff >= 345 && angleDiff <= 360) {
        // 0° 到 30° 之间的刻度逐渐变粉色
        const intensity = (angleDiff - 345) / 15; // 计算渐变强度
        return `rgba(255, 105, 180, ${Math.min(intensity, 1)})`; // 粉色渐变
      } else if (angleDiff >= 0 && angleDiff <= 15) {
        // 30° 到 45° 之间的刻度逐渐变浅
        const intensity = (15 - angleDiff) / 15; // 计算渐变强度
        return `rgba(255, 105, 180, ${Math.max(intensity, 0.2)})`; // 粉色到浅色渐变
      } else {
        // 其他刻度保持浅色
        return 'rgba(200, 200, 200, 0.7)';
      }
    },
    animate() {
      const rotateSpeed = 120; // 每秒 180 度
      let lastTime = performance.now();

      const loop = (now) => {
        const dt = (now - lastTime) / 1000;
        lastTime = now;
        this.currentAngle = (this.currentAngle + rotateSpeed * dt) % 360;
        this.rafId = requestAnimationFrame(loop);
      };

      this.rafId = requestAnimationFrame(loop);
    },
    getCarPosition(rectPoints) {

      // 解析polygon的points属性（格式如 "x1,y1 x2,y2 x3,y3 x4,y4"）
      const xs = [rectPoints[0], rectPoints[2], rectPoints[4], rectPoints[6]];
      // 提取所有y坐标（索引1、3、5、7）
      const ys = [rectPoints[1], rectPoints[3], rectPoints[5], rectPoints[7]];


      const minX = Math.min(...xs); // 长方形左上角x
      const maxX = Math.max(...xs); // 长方形右下角x
      const minY = Math.min(...ys); // 长方形左上角y
      const maxY = Math.max(...ys); // 长方形右下角y

      // 计算长方形中心点坐标
      const centerX = (minX + maxX) / 2;
      const centerY = (minY + maxY) / 2;

      // 计算小车的偏移量（让小车居中，需减去自身宽高的一半）
      const carSize = this.getCarSize(rectPoints); // 复用现有计算大小的方法
      return {
        x: centerX - carSize / 2, // 水平居中
        y: centerY - carSize / 2  // 垂直居中
      };
    },

    getCarRotation(rectPoints) {
      // 提取四个点
      const points = [
        {x: rectPoints[0], y: rectPoints[1]},
        {x: rectPoints[2], y: rectPoints[3]},
        {x: rectPoints[4], y: rectPoints[5]},
        {x: rectPoints[6], y: rectPoints[7]}
      ];

      // 找到最长的边
      let maxLength = 0;
      let longestEdge = {dx: 0, dy: 0};

      for (let i = 0; i < 4; i++) {
        const p1 = points[i];
        const p2 = points[(i + 1) % 4];
        const dx = p2.x - p1.x;
        const dy = p2.y - p1.y;
        const length = Math.sqrt(dx * dx + dy * dy);

        if (length > maxLength) {
          maxLength = length;
          longestEdge = {dx, dy};
        }
      }

      // 计算最长边的角度
      let angle = Math.atan2(longestEdge.dy, longestEdge.dx) * 180 / Math.PI+90;

      // 调整角度，确保小车方向正确
      // 如果小车方向与预期不符，可以加减180度
      return angle;
    },

    // （保持原有的getCarSize方法，用于计算小车大小）
    getCarSize(rect) {
      // 提取车位所有x/y坐标
      const xs = [rect[0], rect[2], rect[4], rect[6]];
      const ys = [rect[1], rect[3], rect[5], rect[7]];
      // 计算车位宽度和高度（包围盒）
      const width = Math.max(...xs) - Math.min(...xs);
      const height = Math.max(...ys) - Math.min(...ys);

      return Math.min(width, height) * 1.4;
    },
    // 处理鼠标滚轮事件
    handleWheel(event) {
      // 计算鼠标相对于包装器的位置
      const rect = this.$refs.wrapper.getBoundingClientRect();
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;

      // 确定缩放方向：向下滚动为缩小，向上滚动为放大
      const zoomIn = event.deltaY < 0;

      // 保存旧的缩放比例
      const oldScale = this.scale;

      // 计算新的缩放比例
      let newScale;
      if (zoomIn) {
        newScale = this.scale + this.scaleStep;
      } else {
        newScale = this.scale - this.scaleStep;
      }

      // 限制缩放范围
      newScale = Math.max(this.minScale, Math.min(this.maxScale, newScale));

      // 应用新的缩放比例
      this.scale = newScale;

      // 调整偏移量以保持鼠标位置下的点不变
      // 这样可以实现以鼠标为中心点的缩放
      if (oldScale !== newScale) {
        // 计算鼠标位置在缩放前的坐标
        const beforeX = (mouseX / oldScale) - this.offsetX;
        const beforeY = (mouseY / oldScale) - this.offsetY;

        // 计算鼠标位置在缩放后应该对应的坐标
        const afterX = (mouseX / newScale) - beforeX;
        const afterY = (mouseY / newScale) - beforeY;

        // 更新偏移量
        this.offsetX += (afterX - this.offsetX);
        this.offsetY += (afterY - this.offsetY);
      }

      // 发出缩放变化事件
      this.$emit('scale-change', this.scale);
    },

    // 开始拖拽
    startDrag(event) {
      this.isDragging = true;
      this.lastMouseX = event.clientX;
      this.lastMouseY = event.clientY;
      // 改变光标样式为抓取中
      this.$refs.wrapper.style.cursor = 'grabbing';
    },

    // 拖拽中
    drag(event) {
      if (!this.isDragging) return;

      // 计算鼠标移动距离
      const deltaX = event.clientX - this.lastMouseX;
      const deltaY = event.clientY - this.lastMouseY;

      // 更新偏移量（注意要除以缩放比例，因为在缩放后移动距离也会受到影响）
      this.offsetX += deltaX / this.scale;
      this.offsetY += deltaY / this.scale;

      // 更新最后鼠标位置
      this.lastMouseX = event.clientX;
      this.lastMouseY = event.clientY;
    },

    // 结束拖拽
    endDrag() {
      this.isDragging = false;
      // 恢复光标样式为可抓取
      this.$refs.wrapper.style.cursor = 'grab';
    },
    getImageSize() {
      const imgElement = this.$refs.image

      imgElement.onload = () => {
        this.imgWidth = imgElement.getBoundingClientRect().width
        this.imgHeight = imgElement.getBoundingClientRect().height
      }
      if (imgElement.complete) {
        imgElement.onload()
      }
    },
    updateImageSize() {
      const imgElement = this.$refs.image
      this.imgWidth = imgElement.getBoundingClientRect().width
      this.imgHeight = imgElement.getBoundingClientRect().height
      this.resetDrawPic();
      this.getThreeMovePoint();
      this.getThreeSpot();

    },
    handleConfirmSwitch() {
      // 关闭弹窗
      this.showConfirmDialog = false;
      // 执行页面切换逻辑（原router-link的跳转）
      this.$router.push({
        name: 'view11',
        query: {robotId: this.robotId}
      });
    },
    async setCurrentRobot() {
      await get("/threeBigscreen/getRobotInfo/" + this.robotId, {}).then((response) => {
        //根据位置信息绘制 角度图
        const ponitMidX = response.data.mFcurx
        const pointMidY = response.data.mFcury
        const svgMidX = (this.processX(ponitMidX, pointMidY) * (this.imgWidth / this.mapOWeight))
        const svgMidY = (this.processY(ponitMidX, pointMidY) * (this.imgHeight / this.mapOHeight))
        this.robotX = svgMidX - 8
        this.robotY = svgMidY - 8
        this.oRobotX = svgMidX;
        this.oRobotY = svgMidY;
        let robotAngle;
        // if ( this.robotId === '4') {
        //   robotAngle = (2 * Math.PI - response.data.mFcuryaw) / (2 * Math.PI) * 360 + 180;
        // } else if (this.robotId === '5') {
        //   robotAngle = (2 * Math.PI - response.data.mFcuryaw) / (2 * Math.PI) * 360 + 95;
        // } else if (this.robotId === '6') {
        //   robotAngle = (2 * Math.PI - response.data.mFcuryaw) / (2 * Math.PI) * 360;
        // }else if(this.robotId === '3' ||this.robotId==='171'||this.robotId==='16'){
        //   robotAngle = (2 * Math.PI - response.data.mFcuryaw) / (2 * Math.PI) * 360;
        // }else if(this.robotId === '173'||this.robotId === '172'){
        //   robotAngle = (2 * Math.PI - response.data.mFcuryaw) / (2 * Math.PI) * 360;
        // }else if(this.robotId === '174'||this.robotId === '175'||this.robotId === '176'||this.robotId === '180'){
        //   robotAngle = (2 * Math.PI - response.data.mFcuryaw) / (2 * Math.PI) * 360-45;
        // }else if(this.robotId === '179'){
        //   robotAngle = (2 * Math.PI - response.data.mFcuryaw) / (2 * Math.PI) * 360-90;
        // }
        console.log(this.mapParam.raw,232323)
        robotAngle = (2 * Math.PI - response.data.mFcuryaw) / (2 * Math.PI) * 360 +this.mapParam.raw;
        this.robotAngleStr = 'rotate(' + robotAngle + ', ' + svgMidX + ', ' + svgMidY + ')';
        this.percentagedianchi = response.data.mNbattery;
        this.option2.series[0].data[0].value = response.data.speed;
        echarts2.setOption(this.option2);
        this.totalDistance = response.data.mDodometry / 1000;
        let percentage = (response.data.mileagepercent * 100).toFixed(2);
        if (parseFloat(percentage) >= 99.9) {
          this.percentagejindu = 100;
        } else {
          this.percentagejindu = parseFloat(percentage);
        }

        if (this.trajectoryPoints !== '') {
          const threshold = 5;
          const laserPts = response.data.m_laserPts;
          if (!Array.isArray(laserPts) || laserPts.length === 0) {
            this.showLeiDa = false;
            this.nowRadarPoint = [];
            return;
          }
          const transformedPoints = laserPts
            .map(point => {
              const x = (this.processX(point.x, point.y) * (this.imgWidth / this.mapOWeight));
              const y = (this.processY(point.x, point.y) * (this.imgHeight / this.mapOHeight));
              const isNearWall = this.wallList.some(wall => {
                const dist = this.getDistanceToLineSegment(
                  x, y,
                  wall.startX, wall.startY,
                  wall.endX, wall.endY
                );
                return dist < threshold;
              });
              const angle = this.getAngleFromCenter(x, y);
              return {
                x,
                y,
                angle,
                isNearWall,
              };
            })
            .filter(point => {
              const px = point.x;
              const py = point.y;
              // 判断是否离机器人太远
              const dx = px - this.oRobotX;
              const dy = py - this.oRobotY;
              const distToRobot = Math.sqrt(dx * dx + dy * dy);
              const isWithinRobotRange = distToRobot < 80;

              // 只保留不靠近墙 & 靠近机器人 的点
              return isWithinRobotRange;
            });
          this.showLeiDa = true;
          this.nowRadarPoint = transformedPoints;
        } else {
          this.radarPoints = [];
          this.nowRadarPoint = [];
          this.showLeiDa = false;
        }
      });
    },
    getAngleFromCenter(x, y) {
      const dx = x - this.oRobotX;
      const dy = y - this.oRobotY;
      let angle = (Math.atan2(dy, dx) * 180 / Math.PI); // 注意 SVG Y轴朝下
      angle = (angle + 90) % 360;
      if (angle < 0) angle += 360;
      return angle;
    },
    isAngleClose(angle, angle1, angle2) {
      return angle >= angle1 && angle < angle2;
    },
    getDistanceToLineSegment(x, y, x1, y1, x2, y2) {
      const dx = x2 - x1;
      const dy = y2 - y1;
      const lengthSquared = dx * dx + dy * dy;
      let t = ((x - x1) * dx + (y - y1) * dy) / lengthSquared;

      t = Math.max(0, Math.min(1, t));  // 限制 t 在 [0, 1] 范围内

      const closestX = x1 + t * dx;
      const closestY = y1 + t * dy;

      const distX = x - closestX;
      const distY = y - closestY;

      return Math.sqrt(distX * distX + distY * distY);
    },
    resetDrawPic() {
      this.setCurrentRobot()
    },
    getThreeMovePoint() {
      // 绘制路线和车位
      that = this;
      get("/threeBigscreen/getThreeMovePoint", {
        robotId: this.robotId,
      }).then((res) => {


        if (res && res.data && Array.isArray(res.data.pointList) && res.data.pointList.length > 0) {
          const newXunipoint = res.data.pointList.map((point) => ({
            pointX: (this.processX(point.pointX, point.pointY) * (this.imgWidth / this.mapOWeight)),
            pointY: (this.processY(point.pointX, point.pointY) * (this.imgHeight / this.mapOHeight))
          }));
          this.trajectoryPoints = newXunipoint.map(p => `${p.pointX},${p.pointY}`).join(' ');
        } else {
          this.trajectoryPoints = '';
        }
      });
    },
    getThreeSpot() {
      // 绘制路线和车位
      that = this;
      get("/threeBigscreen/getThreeSpot", {
        robotId: this.robotId,
      }).then((res) => {
        const data = res.data || [];
        if (Array.isArray(data[0]) && data[0].length > 0) {
          this.temporaryParking = data[0].map(item => [
            (this.processX(item.parkX1, item.parkY1) * (this.imgWidth / this.mapOWeight)), (this.processY(item.parkX1, item.parkY1) * (this.imgHeight / this.mapOHeight)),
            (this.processX(item.parkX2, item.parkY2) * (this.imgWidth / this.mapOWeight)), (this.processY(item.parkX2, item.parkY2) * (this.imgHeight / this.mapOHeight)),
            (this.processX(item.parkX3, item.parkY3) * (this.imgWidth / this.mapOWeight)), (this.processY(item.parkX3, item.parkY3) * (this.imgHeight / this.mapOHeight)),
            (this.processX(item.parkX4, item.parkY4) * (this.imgWidth / this.mapOWeight)), (this.processY(item.parkX4, item.parkY4) * (this.imgHeight / this.mapOHeight))
          ]);

        } else {
          this.temporaryParking = [];
        }

        if (Array.isArray(data[1]) && data[1].length > 0) {
          this.illegalParking = data[1].map(item => [
            (this.processX(item.parkX1, item.parkY1) * (this.imgWidth / this.mapOWeight)), (this.processY(item.parkX1, item.parkY1) * (this.imgHeight / this.mapOHeight)),
            (this.processX(item.parkX2, item.parkY2) * (this.imgWidth / this.mapOWeight)), (this.processY(item.parkX2, item.parkY2) * (this.imgHeight / this.mapOHeight)),
            (this.processX(item.parkX3, item.parkY3) * (this.imgWidth / this.mapOWeight)), (this.processY(item.parkX3, item.parkY3) * (this.imgHeight / this.mapOHeight)),
            (this.processX(item.parkX4, item.parkY4) * (this.imgWidth / this.mapOWeight)), (this.processY(item.parkX4, item.parkY4) * (this.imgHeight / this.mapOHeight))
          ]);

        } else {
          this.illegalParking = [];
        }

        if (Array.isArray(data[2]) && data[2].length > 0) {
          const excludedSpotIds = new Set([
            5406, 5407, 5408, 5409, 5410, 5411, 5412,
            5419, 5420, 5421, 5422, 5423, 5424, 5425, 5426, 5427, 5428, 5429
          ]);

          const occupationParkingTemp = [];
          const temporaryParkingTeShu = [];

          data[2].forEach(item => {
            if (excludedSpotIds.has(item.spotId)) return;

            const transformed = [
              (this.processX(item.parkX1, item.parkY1) * (this.imgWidth / this.mapOWeight)), (this.processY(item.parkX1, item.parkY1) * (this.imgHeight / this.mapOHeight)),
              (this.processX(item.parkX2, item.parkY2) * (this.imgWidth / this.mapOWeight)), (this.processY(item.parkX2, item.parkY2) * (this.imgHeight / this.mapOHeight)),
              (this.processX(item.parkX3, item.parkY3) * (this.imgWidth / this.mapOWeight)), (this.processY(item.parkX3, item.parkY3) * (this.imgHeight / this.mapOHeight)),
              (this.processX(item.parkX4, item.parkY4) * (this.imgWidth / this.mapOWeight)), (this.processY(item.parkX4, item.parkY4) * (this.imgHeight / this.mapOHeight))
            ];

            if (item.spotId === 5453 || item.spotId === 5454) {
              temporaryParkingTeShu.push(transformed);
            } else {
              occupationParkingTemp.push(transformed);
            }
          });

          this.occupationParking = occupationParkingTemp;

          // 合并新增的temporaryParking来源
          this.temporaryParking = [
            ...(this.temporaryParking || []),
            ...temporaryParkingTeShu
          ];

          // 处理 occupationPoints（不包括 spotId 为 99 和 100 的）
          const allPoints = data[2]
            .filter(spot => (
              !excludedSpotIds.has(spot.spotId) &&
              spot.spotId !== 5453 && spot.spotId !== 5454 &&
              Array.isArray(spot.points)
            ))
            .flatMap(spot =>
              spot.points.map(point => ({
                x: this.processX(point.x, point.y) * (this.imgWidth / this.mapOWeight),
                y: this.processY(point.x, point.y) * (this.imgHeight / this.mapOHeight)
              }))
            );

          this.occupationPoints = this.selectKeyPoints(allPoints);
        } else {
          this.occupationParking = [];
          this.occupationPoints = [];
        }


        if (Array.isArray(data[4]) && data[4].length > 0) {
          this.illegalNoParking = data[4]
            // 👇 核心：先过滤掉 x1、y1 都为 0 的无效点位
            .filter(item => {
              // 只有 parkX1 和 parkY1 不同时为 0 才保留
              return !(item.parkX1 === 0 && item.parkY1 === 0);
            })
            // 👇 再计算有效点位的中心坐标
            .map(item => {
              const centerX = this.processX(item.parkX2, item.parkY2) * (this.imgWidth / this.mapOWeight);
              const centerY = this.processY(item.parkX2, item.parkY2) * (this.imgHeight / this.mapOHeight);
              return {
                centerX: centerX,
                centerY: centerY
              };
            });

        } else {
          this.illegalNoParking = []
        }




      });
    },
    getThreeMap() {
      get("/threeBigscreen/getThreeMap", {
        robotId: this.robotId,
      }).then((res) => {
        this.mapImageSrc = res.data.mapUrl;
        this.mapOWeight = res.data.mapX;
        this.mapOHeight = res.data.mapY;
        this.robotName = res.data.remark;

        this.mapParam.xa = Number(res.data.robotMapConvert.xa) || 0;
        this.mapParam.xb = Number(res.data.robotMapConvert.xb) || 0;
        this.mapParam.xc = Number(res.data.robotMapConvert.xc) || 0;
        this.mapParam.ya = Number(res.data.robotMapConvert.ya) || 0;
        this.mapParam.yb = Number(res.data.robotMapConvert.yb) || 0;
        this.mapParam.yc = Number(res.data.robotMapConvert.yc) || 0;
        this.mapParam.raw =  Number(res.data.robotMapConvert.tran) || 0;


        setTimeout(() => {

          this.resetDrawPic()
          this.getThreeMovePoint();
          this.getThreeSpot();
          this.getThreeMapWall()
        }, 1000)
      });
    },
    getThreeMapWall() {
      get("/threeBigscreen/getThreeMapWall", {
        robotId: this.robotId,
      }).then((res) => {
        this.wallList = res.data.map(wall => ({
          startX: (this.processX(wall.startX, wall.startY) * (this.imgWidth / this.mapOWeight)),
          startY: (this.processY(wall.startX, wall.startY) * (this.imgHeight / this.mapOHeight)),
          endX: (this.processX(wall.endX, wall.endY) * (this.imgWidth / this.mapOWeight)),
          endY: (this.processY(wall.endX, wall.endY) * (this.imgHeight / this.mapOHeight))
        }));
      });
    },
    playVideo() {
      get("/threeBigscreen/getLive/" + this.robotId, {}).then((res) => {
        this.videoList = res.data;
        this.player0 = new EZUIKit.EZUIKitPlayer({
          id: "video-container0", // 视频容器ID
          accessToken: this.videoList[0].accessToken,
          url: this.videoList[0].url,
          template: "pcLive",
          width: 450,
          height: 250,
          quality: 0,
        });
        this.player1 = new EZUIKit.EZUIKitPlayer({
          id: "video-container1", // 视频容器ID
          accessToken: this.videoList[1].accessToken,
          url: this.videoList[1].url,
          template: "pcLive",
          width: 450,
          height: 250,
          quality: 0,
        });
        this.player2 = new EZUIKit.EZUIKitPlayer({
          id: "video-container2", // 视频容器ID
          accessToken: this.videoList[2].accessToken,
          url: this.videoList[2].url,
          template: "pcLive",
          width: 450,
          height: 250,
          quality: 0,
        });
      });
    },
    stopRobot() {
      get("/threeBigscreen/threeBigscreen/action/stop/" + this.robotId, {}).then(
        (res) => {
          if (res.code != 200) {
            alert(res.msg);
          } else {
            this.robotState = 0;

          }
        }
      );
    },

    startRobot() {
      get(
        "/threeBigscreen/threeBigscreen/action/start/" + this.robotId,
        {}
      ).then((res) => {
        if (res.code != 200) {
          alert("操作失败");
        } else {
          this.robotState = 1;

        }
      });
    },

    pauseRobot() {
      get("/threeBigscreen/action/pauseMode/" + this.robotId, {}).then((res) => {
        if (res.code != 200) {
          alert("操作失败");
        } else {
          this.robotState = 2;

        }
      });
    },
    resumetRobot() {
      get("/threeBigscreen/action/resume/" + this.robotId, {}).then((res) => {
        if (res.code != 200) {
          alert("操作失败");
        } else {
          this.robotState = 3;

        }
      });
    },
    goHome() {
      get("/threeBigscreen/action", {
        action: "back",
        robotId: this.robotId,
      }).then((res) => {
        if (res.code != 200) {
          alert("操作失败");
        } else {
          alert("操作成功");
        }
      });
    },
    openDia(row, ceil, rowIndex, columnIndex) {
      this.alertIndex = row.rowIndex;
      // this.showDia = true;
    },
    //告警信息
    getBizSpotRecordWarnByState() {
      get("/threeBigscreen/warn/" + this.robotId, {}).then((res) => {

        const params = {};
        params.robotType = 3;
        params.parkId = 1;

        get("/park/illegal/getParkIllegalList", params).then((res2) => {
          if (res.data == null && res2.data == null) {
            return;
          }
          let list = [];
          let list1 = res.data;
          let list2 = res2.rows;
          let a = [];

          if (list1.length > 0) {
            list1.forEach((item, index) => {
              if (item.endTime == null) {

                a.push(item.warnContent);
                a.push("系统告警");

                list.push(a);

                a = [];
              }
            });
          }
          list2.forEach((item, index) => {


            let b = [];
            b.push(item.warnMessage);
            b.push("异常车牌");
            list.push(b)

          });


          let da = JSON.parse(JSON.stringify(this.config2));

          da.data = list;
          this.config2 = da;

          this.alertTip = res.data;


        });


      });


    },
    //任务列表
    getRobotTasks() {
      get("/threeBigscreen/task/" + this.robotId, {}).then((res) => {
        // if (!res.state) {
        //   return;
        // }
        if (res.data == null) {
          return;
        }
        let list = [];
        let list1 = res.data;
        let a = [];

        list1.forEach((item, index) => {
          // a.push(index + 1 + "");

          if (item.type === "1") {
            a.push("巡逻任务");
          } else {
            a.push("目标任务");
          }


          a.push(item.time === '未开始' ? '未开始' : item.time.substr(5));
          // if (item.taskStatus == 1) {
          //   a.push("进行中");
          // } else if (item.taskStatus == 2) {
          //   a.push("队列中");
          // } else if (item.taskStatus == 3) {
          //   a.push("已结束");
          // } else {
          //   a.push("挂起");
          // }

          list.push(a);
          a = [];
        });
        let da = JSON.parse(JSON.stringify(this.config));
        this.config = da;
        da.data = list;
      });
    },
    //获取网速
    getNetspeed() {
      // 获取 Performance API 中的所有网络请求数据
      const entries = performance.getEntries();
      let totalSize = 0; // 总大小，单位为 KB
      let totalTime = 0; // 总时间，单位为秒
      entries.forEach((entry) => {
        if (entry.transferSize > 0) {
          totalSize += entry.transferSize / 1024;
          totalTime += entry.responseEnd - entry.requestStart;
        }
      });
      // 计算平均速率
      const speed = (totalSize / totalTime).toFixed(2);
      console.log(speed);
      this.option3.series[0].data[0].value = speed;
      echarts3.setOption(this.option3);
    },
    measureNetworkSpeed() {
      const startTime = Date.now()
      const cacheBuster = `?cache=${startTime}` // 防止缓存
      const testUrl = `https://cdnjs.cloudflare.com/ajax/libs/vue/2.6.14/vue.min.js${cacheBuster}`;

      // 使用Performance API来测量
      const resourceTimingData = []

      // 创建资源计时观察器
      const observer = new PerformanceObserver((list) => {
        const entries = list.getEntries()
        resourceTimingData.push(...entries)
      })

      // 观察资源加载计时
      observer.observe({entryTypes: ['resource']})

      // 使用fetch API加载测试文件
      fetch(testUrl, {method: 'GET', cache: 'no-store'})
        .then(response => response.blob())
        .then(blob => {
          // 找到对应的资源计时条目
          const entry = resourceTimingData.find(e => e.name.includes(testUrl.split('?')[0]))

          if (entry) {
            // 计算加载时间(秒)
            const loadTime = (entry.responseEnd - entry.startTime) / 1000
            // 文件大小(字节)
            const fileSizeInBytes = blob.size

            // 计算速度 (MB/s)
            if (loadTime > 0) {
              // 转换为MB/s (字节/秒 转换为 MB/秒)
              this.option3.series[0].data[0].value = (fileSizeInBytes / loadTime / (1024 * 1024)).toFixed(2)
              echarts3.setOption(this.option3);
            }
          } else {
            // 使用备用方法：基于文件大小和加载时间
            const endTime = Date.now()
            const duration = (endTime - startTime) / 1000

            if (duration > 0) {
              // 假设文件大小接近于请求的大小
              this.option3.series[0].data[0].value = (blob.size / duration / (1024 * 1024)).toFixed(2)
              echarts3.setOption(this.option3);
            }
          }

          // 断开观察器
          observer.disconnect()
        })
        .catch(error => {
          console.error('网速测量失败:', error)
          this.option3.series[0].data[0].value = 0;
          echarts3.setOption(this.option3);
          observer.disconnect()
        })
    },
    getNetspeed2() {
      const entries = performance.getEntries();
      // 总大小，单位为 bytes
      let totalSize = 0;
      // 总时间，单位为秒
      let totalTime = 0;

      entries.forEach((entry) => {
        // 忽略缓存的资源
        if (entry.transferSize > 0) {
          totalSize += entry.transferSize;
          totalTime += (entry.responseEnd - entry.requestStart) / 1000;
        }
      });

      const speed = totalTime > 0 ? (totalSize / 1024 / 1024 / totalTime).toFixed(2) : 0;

      console.log(`${speed} MB/s`);
      this.option3.series[0].data[0].value = speed;
      echarts3.setOption(this.option3);
      // try {
      //   // 获取 Performance API 中的所有网络请求数据，仅选择 `resource` 类型的条目
      //   const entries = performance.getEntriesByType('resource');
      //   let totalSize = 0; // 总大小，单位为 KB
      //   let totalTime = 0; // 总时间，单位为秒
      //
      //   entries.forEach((entry) => {
      //     // 检查 entry.transferSize 和时间间隔是否有效
      //     if (
      //       entry.transferSize > 0 &&
      //       entry.responseEnd > entry.requestStart
      //     ) {
      //       totalSize += entry.transferSize / 1024; // 转换为 KB
      //       totalTime += (entry.responseEnd - entry.requestStart) / 1000; // 转换为秒
      //     }
      //   });
      //
      //   // 计算平均速率，避免除以零
      //   const speed = totalTime > 0 ? (totalSize / totalTime).toFixed(2) : 0;
      //
      //   console.log(`Average Speed: ${speed} KB/s`);
      //   // 更新图表数据
      //   this.option3.series[0].data[0].value = speed;
      //   echarts3.setOption(this.option3);
      // } catch (error) {
      //   console.error('Error calculating network speed:', error);
      // }
    },
    getjindu() {
      get("/threeBigscreen/taskInfo/" + this.robotId, {}).then((res) => {
        this.startTime = res.data.startTime;
        this.duration = res.data.duration;
        this.robotStatus = res.data.status;
        this.percentageUnfinished = (res.data.parkingNums > 0)
          ? Math.max(0, Math.round(((res.data.parkingNums - res.data.doneNums) / res.data.parkingNums) * 100))
          : 0;
        this.illegalParkings = res.data.illegalParkings;
      });
    },
    getTotalDuration() {
      get("/threeBigscreen/totalDuration/" + this.robotId, {}).then((res) => {
        this.totalDuration = res.data;
      });
    },
    getCarTransform(pointsStr) {
      const points = this.parseRectPoints(pointsStr);
      const {centerX, centerY, width, height, angle} = this.getRectInfo(points);

      // 1. 分析原始path的尺寸（通过d属性估算，你的path是一个宽~400、高~800的图形）
      const originalWidth = 400;  // 原始path的近似宽度
      const originalHeight = 800; // 原始path的近似高度

      // 2. 计算缩放比例（让path适应长方形，预留10%边距）
      const scaleX = (width * 0.8) / originalWidth;  // 宽度方向缩放（80%占比）
      const scaleY = (height * 0.8) / originalHeight; // 高度方向缩放（80%占比）
      const scale = Math.min(scaleX, scaleY); // 取最小比例，避免超出

      // 3. 计算原始path的中心偏移（你的path原始中心不在(0,0)，需要修正）
      // 原始path的大致中心（通过d属性估算，可根据实际调整）
      const pathOriginalCenterX = 430;
      const pathOriginalCenterY = 400;

      // 4. 组合transform：先平移到原点→缩放→平移到长方形中心→旋转（如果需要）
      return `
      translate(${-pathOriginalCenterX}, ${-pathOriginalCenterY})  // 把path中心移到自身原点
      scale(${scale})                                           // 缩放
      translate(${centerX}, ${centerY})                         // 平移到长方形中心
      rotate(${angle}, ${centerX}, ${centerY})`;
    },
    parseRectPoints(pointsStr) {
      console.log(pointsStr)
      if (pointsStr.length !== 8) {
        console.warn(`无效的points格式，期望8个数值，实际得到${pointsStr.length}个:`, pointsStr);
        return [];
      }

      // 3. 每2个数值组成一个点（x,y），共4个点
      const points = [];
      for (let i = 0; i < 8; i += 2) {
        points.push({
          x: pointsStr[i],
          y: pointsStr[i + 1]
        });
      }

      return points;
    },

    // 计算长方形的中心坐标、宽高、旋转角度
    getRectInfo(points) {
      // 取长方形的四个顶点（假设顺序：左上、右上、右下、左下）
      const [p1, p2, p3, p4] = points;

      // 计算中心坐标（对角线中点）
      const centerX = (p1.x + p3.x) / 2;
      const centerY = (p1.y + p3.y) / 2;

      // 计算宽度（上边长）和高度（左边长）
      const width = Math.hypot(p2.x - p1.x, p2.y - p1.y); // 两点间距离公式
      const height = Math.hypot(p4.x - p1.x, p4.y - p1.y);

      // 计算旋转角度（如果是斜长方形，可选）
      const angle = Math.atan2(p2.y - p1.y, p2.x - p1.x) * (180 / Math.PI);

      return {centerX, centerY, width, height, angle};
    },


    getTime() {
      var date = new Date();
      var year = date.getFullYear();
      var mon = date.getMonth() + 1;
      var da = date.getDate(); //获取当前日

      var day = date.getDay();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      var submitTime = "";
      submitTime += year + "-";
      if (mon >= 10) {
        // submitTime += mon + "-";
      } else {
        mon = "0" + mon;
      }
      if (da >= 10) {
        // submitTime += day;
      } else {
        da = "0" + da;
      }
      submitTime += " ";
      if (h >= 10) {
        // submitTime += h + ":";
      } else {
        h = "0" + h;
      }
      if (m >= 10) {
        // submitTime += m;
      } else {
        m = "0" + m;
      }
      if (s < 10) {
        s = "0" + s;
      }
      var weeks = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      );
      this.y1 = year + "年" + mon + "月" + da + "日";
      this.y2 = weeks[day] + " " + h + ":" + m + ":" + s;
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  position: relative;
  width: 100%;

  overflow: hidden;
}

.myvideo {
  width: 450px;
  height: auto;
}

.shouzhi {
  cursor: pointer;
}

.olo {
  border: 1px solid #ffffff;
  width: 200px;
  height: 200px;
}

.wancheng {
  margin-left: -184px;
  margin-top: -20px;
}

.dianchi {
  position: relative;
  top: -107px;
  left: 30px;
}

.chartsv3 {
  width: 150px;
  height: 150px;
  /* border: 1px solid red; */
  margin-top: -25px;
  margin-left: -5px;
}

.echarts2 {
  position: relative;
  left: 14px;
  top: -141px;
  width: 150px;
  height: 150px;
  /* border: 1px solid red; */
}

.echarts3 {
  /* border: 1px solid red; */
  width: 150px;
  height: 150px;
  position: relative;
  left: 63px;
  top: -97px;
}

.text-wrapper_01 {
  width: 330px;
  height: 19px;
  margin: -30px 0 10px 11px;
  /* border: 1px solid white; */
}

.wanc {
  margin: 205px 0 0 -135px;
}

.wangs {
  color: rgba(0, 255, 246, 1);
  font-size: 12px;
  position: relative;
  top: -158px;
  left: 125px;
}

.yis {
  color: rgba(0, 255, 246, 1);
  font-size: 12px;
  position: relative;
  top: -202px;
  left: 78px;
}

.dian2 {
  margin-top: -80px;
}

.centerContenttxt3 {
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 400;
  color: #ffffff;
}

.oneline {
  display: flex;
  justify-content: space-around;

  margin-top: 8px;
}

.centerContenttxt2 {
  font-size: 20px;
  font-family: DIN-Bold;
  font-weight: bold;
  color: #ffffff;
}

.left2center_col3table {
  //   width: 400px;
  height: 100px;
  margin-top: 140px;

  ::v-deep .header-item {
    font-size: 20px !important;
    font-family: SourceHanSansSC-Bold !important;
    font-weight: bold !important;
    color: rgba(0, 255, 246, 1);
    background-color: #1b569b;
  }

  ::v-deep .row-item {
    color: #6b7cab;
    // color: #90a9c8;
    font-size: 20px !important;
    font-family: SourceHanSansSC-Regular !important;
    font-weight: bold !important;
    // margin-bottom: 12px !important;
  }
}

.bottomContent3txt2tablev3 {
  height: 100px;
  margin-top: -0px;

  ::v-deep .header-item {
    font-size: 20px !important;
    font-family: SourceHanSansSC-Bold !important;
    font-weight: bold !important;
    color: rgba(0, 255, 246, 1);
    background-color: #1b569b;
  }

  ::v-deep .row-item {
    color: #6b7cab;
    // color: #90a9c8;
    font-size: 20px !important;
    font-family: SourceHanSansSC-Regular !important;
    font-weight: bold !important;
    // margin-bottom: 12px !important;
  }
}

.ku1 {
  position: relative;
  top: -190px;
  left: 37px;
  width: 100px;
  height: 60px;
  text-align: center;
}

.ku_c1 {
  color: rgba(0, 255, 246, 1);
  font-size: 20px;
  font-family: DIN-Bold;
  font-weight: 700;
}

.ku_c2 {
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
}

.ku2_c1 {
  color: rgba(0, 255, 246, 1);
  font-size: 20px;
  font-family: DIN-Bold;
  font-weight: 700;
}

.ku2 {
  width: 100px;
  height: 60px;
  text-align: center;
  margin: -80px 0 0 -180px;
}

.ku2_c2 {
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
}

.text_01 {
  width: 146px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.text_011 {
  color: rgba(254, 254, 255, 1);
  position: absolute;
}

.text_02 {
  width: 177px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.group_1 {
  width: 1980px;
  height: 1080px;
  background: url(~@/assets/ps14qu5lgw2pl7e6gs1uuj5eu7uy4zkstbof890a1a6-0e90-4243-9adc-4dcdc3cb1a77.png) 100% no-repeat;
  background-size: 100% 100%;
}

.image_1 {
  width: 1916px;
  height: 94px;
}

.group_2 {
  width: 1980px;
  height: 987px;
  margin-bottom: 1px;
}

.box_1 {
  position: relative;
  width: 1920px;
  height: 327px;
  background: url(~@/assets/ps94kz3bggzj7bay9tdnarq4eusqmhelgad8fed6dfb-d4a6-469c-8fae-898e2676eb03.png) 100% no-repeat;
  background-size: 100% 100%;
  margin: 8px 0 0 0px;
}

.group_3 {
  width: 364px;
  height: 240px;
  margin: 46px 0 0 85px;
}

.section_1 {
  width: 209px;
  height: 19px;
  margin-left: 14px;
}

.thumbnail_1 {
  width: 14px;
  height: 14px;
  margin-top: 3px;
}

.text_1 {
  width: 78px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 14px;
}

.text_2 {
  width: 83px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 2px 0 0 20px;
}

.text_3 {
  width: 210px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 10px 0 0 139px;
}

.section_2 {
  width: 267px;
  height: 23px;
  margin: 19px 0 0 18px;
}

.box_2 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 6px;
}

.text_4 {
  width: 118px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 16px;
}

.image_2 {
  width: 24px;
  height: 18px;
  margin: 3px 0 0 17px;
}

.label_1 {
  width: 24px;
  height: 23px;
  margin-left: 19px;
}

.image_3 {
  width: 22px;
  height: 20px;
  margin: 3px 0 0 21px;
}

.section_3 {
  width: 346px;
  height: 20px;
  margin: 15px 0 0 18px;
}

.group_4 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 7px;
}

.text_5 {
  width: 100px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 15px;
}

.group_5 {
  background-color: rgba(0, 255, 246, 0.3);
  border-radius: 5px;
  height: 10px;
  border: 1px solid rgba(0, 255, 246, 1);
  width: 198px;
  margin: 8px 0 0 27px;
}

.box_3 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 5px;
  height: 10px;
  margin-left: -1px;
  width: 98px;
}

.group_6 {
  box-shadow: 0px 1px 5px 0px rgba(9, 184, 202, 1);
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 14px;
  height: 14px;
  margin: -1px 0 0 91px;
}

.text_6 {
  width: 23px;
  height: 9px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 12px;
  font-family: DIN-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: 3px 0 0 251px;
}

.text_06 {
  width: 23px;
  height: 9px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 20px;
  font-family: DIN-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: -60px 0 0 -155px;
}

.section_4 {
  width: 196px;
  height: 19px;
  margin: 1px 0 0 18px;
}

.block_1 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 7px;
}

.text_7 {
  width: 140px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 17px;
}

.text_8 {
  width: 23px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 2px 0 0 10px;
}

.text-wrapper_1 {
  height: 49px;
  background: url(~@/assets/psdxn2purxggwcp6u2ks8dexregofmkguo4cba6b37-8bfa-4b01-9ab8-d5b06b66325b.png) 100% no-repeat;
  background-size: 100% 100%;
  margin-top: 29px;
  width: 363px;
}

.text_9 {
  width: 159px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 14px 0 0 102px;
}

.group_7 {
  width: 178px;
  height: 231px;
  margin: 48px 0 0 9px;
}

.image_4 {
  width: 178px;
  height: 136px;
}

.image_100 {
  margin: auto;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.text-wrapper_2 {
  height: 99px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/pswzx3fmh7kotyu2pb558exvmhw6fh5c7d7b7b76-fddf-4b34-920c-63fee297dd9b) 100% no-repeat;
  background-size: 100% 100%;
  width: 140px;
  margin: -4px 0 0 20px;
}

.text_10 {
  width: 59px;
  height: 12px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: -55px 0 0 43px;
}

.image-wrapper_1 {
  width: 177px;
  height: 135px;
  margin: 180px 0 0 10px;
}

.image_5 {
  width: 177px;
  height: 136px;
  position: relative;
  left: 50px;
  top: 50px;
}

.image_6 {
  width: 139px;
  height: 99px;
  margin: 10px 0 0 15px;
}

.image_7 {
  width: 130px;
  height: 215px;
  margin: 64px 0 0 36px;
  /* border: 1px solid white; */
}

.image_07 {
  height: 324px;
  width: 576px;
  /* position: absolute; */
  position: relative;
  left: -220px;
  top: -60px;

  -webkit-backface-visibility: hidden;
  background: transparent;
}

.group_8 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 3px;
  width: 22px;
  height: 23px;
  margin: 139px 0 0 18px;
}

.text-wrapper_3 {
  width: 47px;
  height: 188px;
  // margin: 58px 0 0 34px;
  position: relative;
  z-index: 999;
  top: 60px;
  left: 30px;
}

.text_11 {
  width: 47px;
  height: 23px;
  overflow-wrap: break-word;
  color: rgba(147, 255, 255, 1);
  font-size: 24px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
}

.text_12 {
  width: 46px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 24px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 33px 0 0 1px;
}

.text_13 {
  width: 46px;
  height: 23px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 24px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 32px 0 0 1px;
}

.text_14 {
  width: 46px;
  height: 23px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 24px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  margin: 32px 0 0 1px;
}

.gogo {
  float: right;
  margin-left: -900px;
  margin-top: 280px;
  z-index: 99;
}

.gogo2 {
  float: right;
  margin-left: -300px;
  margin-top: 280px;
  z-index: 99;
}

.group_9 {
  width: 128px;
  height: 243px;
  position: relative;
  left: 60px;
  top: 50px;
}

.text-wrapper_4 {
  height: 46px;
  background: url(~@/assets/psqjxjcbwaekij15xdbdedef4yeflcjc28vb9578ee7-ea79-4e55-82c5-66fa2cdc7be6.png) 100% no-repeat;
  background-size: 100% 100%;
  width: 128px;
}

.text_155 {
  text-shadow: 0px -4px 6px rgba(255, 255, 255, 0.56);
  width: 42px;
  height: 21px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 22px;
  font-family: Adobe Heiti Std R;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 22px;
  margin: 12px 0 0 20px;
}

.text_15 {
  text-shadow: 0px -4px 6px rgba(255, 255, 255, 0.56);
  width: 42px;
  height: 21px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 22px;
  font-family: Adobe Heiti Std R;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 22px;
  margin: 12px 0 0 43px;
}

.box_4 {
  height: 40px;
  background: url(~@/assets/psbvoch0uz85p2yakpvewn2e3jkr5hdartbc21b4c63-3e02-403f-b5af-0b63b983ab53.png) -4px -4px no-repeat;
  background-size: 128px 46px;
  width: 120px;
  margin: 18px 0 0 4px;
}

.text-wrapper_5 {
  height: 30px;
  background: url(~@/assets/psasu9x8meui7e73mj2ddbjdpxmd0h8ac37e57dc9f7-0efe-4059-a8f5-1ed7994c494d.png) -4px -4px no-repeat;
  background-size: 109px 36px;
  width: 101px;
  margin: 5px 0 0 8px;
}

.text_16 {
  text-shadow: 0px -4px 6px rgba(255, 255, 255, 0.56);
  width: 88px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 22px;
  font-family: Adobe Heiti Std R;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 22px;
  margin: 3px 0 0 7px;
}

.text-wrapper_6 {
  width: 121px;
  height: 121px;
  background: url(~@/assets/psqacbkppi2o226mn9x8o28fdozbid2rg435a2a5d6-3def-4b16-81e4-2abf0d97449d.png) 100% no-repeat;
  background-size: 100% 100%;
  margin: 18px 0 0 3px;
}

.text_17 {
  width: 79px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 19px 0 0 21px;
}

.text_18 {
  width: 87px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 13px 0 0 17px;
}

.text_19 {
  width: 75px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 8px 0 22px 23px;
}

.group_10 {
  width: 514px;
  height: 239px;
  position: relative;
  top: 30px;
  left: 100px;
}

.box_5 {
  width: 509px;
  height: 23px;
}

.label_2 {
  margin-top: 15px;
  margin-left: 25px;
  width: 24px;
  height: 23px;
}

.text_20 {
  width: 71px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin: 4px 0 0 12px;
}

.text_21 {
  width: 133px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin: 4px 0 0 22px;
}

.text_22 {
  width: 70px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin: 4px 0 0 26px;
}

.text_23 {
  width: 126px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin: 6px 0 0 25px;
}

.text-wrapper_7 {
  width: 511px;
  height: 29px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psep9iif4b5uirr0gyaxr1pls8yegrs2y49bc42e1-e65e-4c8e-a76e-b489e620f253) -1px 0px no-repeat;
  background-size: 513px 29px;
  margin: 15px 0 0 1px;
}

.text_24 {
  width: 31px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 6px 0 0 17px;
}

.text_25 {
  width: 63px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 6px 0 0 44px;
}

.text_26 {
  width: 95px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 6px 35px 0 226px;
}

.text-wrapper_8 {
  width: 452px;
  height: 19px;
  margin: 16px 0 0 32px;
}

.text_27 {
  width: 9px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 2px;
}

.text_28 {
  width: 38px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 53px;
}

.text_29 {
  width: 101px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 251px;
}

/* 修复确认按钮样式，使用页面主色调（与进度条颜色一致） */
::v-deep .custom-dialog .el-dialog__footer {
  padding: 15px 20px 20px;
}

::v-deep .confirm-btn {
  background-color: #00FFF6 !important;
  border-color: #00FFF6 !important;
  color: #000 !important; /* 深色文字确保与浅色背景对比 */
}

::v-deep .confirm-btn:hover {
  background-color: #00e5e0 !important;
  border-color: #00e5e0 !important;
}

.text-wrapper_9 {
  width: 432px;
  height: 20px;
  margin: 15px 0 0 31px;
}

.text_30 {
  width: 10px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 1px;
}

.text_31 {
  width: 79px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 52px;
}

.text_32 {
  width: 80px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 1px 0 0 211px;
}

.text-wrapper_10 {
  width: 432px;
  height: 20px;
  margin: 14px 0 0 31px;
}

.text_33 {
  width: 10px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 1px;
}

.text_34 {
  width: 39px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 52px;
}

.text_35 {
  width: 81px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 1px 0 0 250px;
}

.text-wrapper_11 {
  width: 432px;
  height: 19px;
  margin: 15px 0 0 31px;
}

.text_36 {
  width: 11px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 2px;
}

.text_37 {
  width: 38px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 52px;
}

.text_38 {
  width: 81px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 250px;
}

.text-wrapper_12 {
  width: 483px;
  height: 20px;
  margin: 14px 0 0 31px;
}

.text_39 {
  width: 10px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 3px;
}

.text_40 {
  width: 39px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 52px;
}

.text_41 {
  width: 131px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 1px 0 0 251px;
}

.group_11 {
  border-radius: 50%;
  position: absolute;
  left: 99px;
  top: 197px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}

.group_12 {
  border-radius: 50%;
  position: absolute;
  left: 99px;
  top: 125px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}

.group_13 {
  border-radius: 50%;
  position: absolute;
  left: 99px;
  top: 165px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}

.image_8 {
  position: absolute;
  left: 1054px;
  top: 66px;
  width: 38px;
  height: 87px;
}

.image_82 {
  position: absolute;
  left: 1054px;
  top: 152px;
  width: 38px;
  height: 87px;
  display: inline-block;
  -moz-transform: scaleY(-1);
  -webkit-transform: scaleY(-1);
  -o-transform: scaleY(-1);
  transform: scaleY(-1);
}

.image_83 {
  position: absolute;
  left: 1054px;
  top: 115px;
  width: 38px;
  height: 47px;
  -moz-transform: rotate(40deg);
  -webkit-transform: rotate(40deg);
}

.image_84 {
  position: absolute;
  left: 1054px;
  top: 145px;
  width: 38px;
  height: 47px;

  // display: inline-block;
  // -moz-transform: scaleY(-1);
  // -webkit-transform: scaleY(-1);
  // -o-transform: scaleY(-1);
  // transform: scaleY(-1);
  -moz-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
}

.box_6 {
  width: 1930px;
  height: 620px;
  margin: 13px 0 19px 25px;
}

.block_2 {
  width: 957px;
  height: 620px;
  background: url(~@/assets/ps42gzovgpbmwg39dcyz8z97x97avyhahi2d934119-1aad-4130-99a1-34d7a6d49697.png) 100% no-repeat;
  background-size: 100% 100%;
}

.box_7 {
  width: 891px;
  height: 40px;
  margin: 26px 0 0 25px;

  z-index: 999;
}

.thumbnail_2 {
  width: 35px;
  height: 20px;
  margin-top: 8px;
}

.text_42 {
  width: 77px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 8px 0 0 15px;
}

.group_14 {
  height: 40px;
  background: url(~@/assets/psasqcy1of5w8mhbybwotujj24oq7skh5b38fea35-cd24-429d-86f7-aaef6f811a00.png) -4px -4px no-repeat;
  background-size: 128px 46px;
  margin-left: 19px;
  width: 120px;
}

.text-wrapper_13 {
  height: 30px;
  background: url(~@/assets/ps0schzh0nr5uml77i7wv3cr5ed91z840hv24f2cd52-8c5f-438d-91d9-67f4d30b5dbd.png) -4px -4px no-repeat;
  background-size: 109px 36px;
  width: 101px;
  margin: 5px 0 0 8px;
}

.text_43 {
  text-shadow: 0px -4px 6px rgba(255, 255, 255, 0.56);
  width: 72px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin: 7px 0 0 15px;
}

.thumbnail_3 {
  width: 35px;
  height: 20px;
  margin: 8px 0 0 60px;
}

.text_44 {
  width: 80px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 8px 0 0 14px;
}

.group_15 {
  height: 40px;
  background: url(~@/assets/pspkrrx6y2xynsgxkmf3ytg1wt4ldj5gd1ie54fa3d6-b464-4df3-a4cc-a238ae261827.png) -4px -4px no-repeat;
  background-size: 128px 46px;
  margin-left: 18px;
  width: 120px;
}

.text-wrapper_14 {
  height: 30px;
  background: url(~@/assets/pse5jdk1cmozk5koelj0w19c4d7va6h7oj3b4cb7d6d-018c-4bb8-99d3-e26fa7057fb2.png) -4px -4px no-repeat;
  background-size: 109px 36px;
  width: 101px;
  margin: 5px 0 0 8px;

}

.text_45 {
  text-shadow: 0px -4px 6px rgba(255, 255, 255, 0.56);
  width: 71px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin: 7px 0 0 16px;
  display: inline-block; /* 使行内元素可扩展 */


}

.thumbnail_4 {
  width: 35px;
  height: 20px;
  margin: 8px 0 0 60px;
}

.text_46 {
  width: 80px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 8px 0 0 14px;
}

.group_16 {
  height: 40px;
  background: url(~@/assets/ps4kbb79z649cg23dh5fekzb187owdojk7w2bd98073-bf3a-4321-9dc4-51b56e3f1a95.png) -4px -4px no-repeat;
  background-size: 128px 46px;
  margin-left: 16px;
  width: 120px;
}

.text-wrapper_15 {
  height: 30px;
  background: url(~@/assets/ps8takumiak07tl3duu8difaiz6niho0lvraef4c056-b1b5-4931-bd3a-43742886503a.png) -4px -4px no-repeat;
  background-size: 109px 36px;
  width: 101px;
  margin: 5px 0 0 8px;
}

.text_47 {
  text-shadow: 0px -4px 6px rgba(255, 255, 255, 0.56);
  width: 71px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin: 7px 0 0 16px;
}

.box_8 {
  height: 516px;
  border: 1px solid rgba(0, 0, 0, 1);
  width: 920px;
  margin: 20px 0 18px 19px;
  display: flex;
  align-items: center; /*垂直居中*/
  justify-content: center; /*水平居中*/
}

.image-wrapper_2 {
  width: 18px;
  height: 6px;
  margin: 125px 0 0 230px;
}

.thumbnail_5 {
  width: 18px;
  height: 6px;
}

.image-wrapper_3 {
  width: 18px;
  height: 6px;
  margin: 25px 0 0 230px;
}

.thumbnail_6 {
  width: 18px;
  height: 6px;
}

.image-wrapper_4 {
  width: 18px;
  height: 6px;
  margin-left: 430px;
}

.thumbnail_7 {
  width: 18px;
  height: 6px;
}

.image-wrapper_5 {
  width: 18px;
  height: 6px;
  margin: 10px 0 0 430px;
}

.thumbnail_8 {
  width: 18px;
  height: 6px;
}

.image-wrapper_6 {
  width: 18px;
  height: 6px;
  margin: 10px 0 0 430px;
}

.thumbnail_9 {
  width: 18px;
  height: 6px;
}

.image-wrapper_7 {
  width: 18px;
  height: 6px;
  margin: 4px 0 0 729px;
}

.thumbnail_10 {
  width: 18px;
  height: 6px;
}

.image-wrapper_8 {
  width: 18px;
  height: 6px;
  margin-left: 430px;
}

.thumbnail_11 {
  width: 18px;
  height: 6px;
}

.image-wrapper_9 {
  width: 18px;
  height: 6px;
  margin: 4px 0 0 729px;
}

.thumbnail_12 {
  width: 18px;
  height: 6px;
}

.image-wrapper_10 {
  width: 18px;
  height: 6px;
  margin: 10px 0 0 729px;
}

.thumbnail_13 {
  width: 18px;
  height: 6px;
}

.image-wrapper_11 {
  width: 18px;
  height: 6px;
  margin: 10px 0 0 729px;
}

.thumbnail_14 {
  width: 18px;
  height: 6px;
}

.image-wrapper_12 {
  width: 18px;
  height: 6px;
  margin: 31px 0 0 199px;
}

.thumbnail_15 {
  width: 18px;
  height: 6px;
}

.image-wrapper_13 {
  width: 18px;
  height: 6px;
  margin: 12px 0 0 199px;
}

.thumbnail_16 {
  width: 18px;
  height: 6px;
}

.image-wrapper_14 {
  width: 18px;
  height: 6px;
  margin: 12px 0 0 199px;
}

.thumbnail_17 {
  width: 18px;
  height: 6px;
}

.image-wrapper_15 {
  width: 18px;
  height: 6px;
  margin: 12px 0 167px 199px;
}

.thumbnail_18 {
  width: 18px;
  height: 6px;
}

.block_3 {
  height: 620px;
  background: url(~@/assets/ps9m1y7h931xo6qy5mq4xfg3q37ho3ew6i5495c315-7c4d-426c-9abd-fbe14336b4cf.png) 100% no-repeat;
  background-size: 100% 100%;
  width: 957px;
  justify-content: flex-center;
}

.block_4 {
  width: 902px;
  height: 41px;
  margin: 23px 0 0 22px;
}

.image-text_1 {
  width: 188px;
  height: 26px;
  margin-top: 3px;
}

.image_9 {
  width: 24px;
  height: 15px;
  margin-top: 5px;
}

.text-group_1 {
  width: 154px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 26px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.group_17 {
  width: 123px;
  height: 41px;
  background-size: 125px 41px;
  margin-left: 442px;
}

.image-text_2 {
  width: 86px;
  height: 17px;
  margin: 12px 0 0 18px;
}

.text-group_2 {
  width: 54px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.thumbnail_19 {
  width: 17px;
  height: 11px;
  margin-top: 3px;
}

.group_18 {
  height: 40px;
  background: url(~@/assets/psbvi4t94iefe9or9rrn7p70amzkpkwtc2faddca6-1e3a-4327-ba4c-b150426ccdad.png) -4px -4px no-repeat;
  background-size: 128px 46px;
  width: 120px;
  margin: 1px 0 0 29px;
}

.text-wrapper_16 {
  height: 36px;
  background: url(~@/assets/pscnnv9m32qfkef1wyubtt930gewnesvzkd107ac0b-d12e-4469-af99-f4e7902c189c.png) 100% no-repeat;
  background-size: 100% 100%;
  width: 109px;
  margin: 1px 0 0 4px;
}

.text_48 {
  text-shadow: 0px -4px 6px rgba(255, 255, 255, 0.56);
  width: 71px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin: 10px 0 0 20px;
}

.block_5 {
  width: 902px;
  height: 252px;
  margin: 23px 0 0 23px;
}

.block_7 {
  width: 902px;
  height: 504px;
  margin: 23px 0 0 23px;
}

.video-box {
  width: 500px;
  height: 250px;
}

.box_9 {
  height: 251px;

  width: 447px;
}

.text-wrapper_17 {
  height: 251px;

  width: 447px;
  border: 1px solid red;
}

.text_49 {
  width: 257px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 15px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 15px;
  margin: 13px 0 0 11px;
}

.image_10 {
  width: 447px;
  height: 251px;
  margin-top: 1px;
}

.block_6 {
  width: 902px;
  height: 251px;
  margin: 7px 0 23px 23px;
}

.text-wrapper_18 {
  height: 251px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/e2e64426f06143a6bb73a7b1566c14f7_mergeImage.png) 100% no-repeat;
  background-size: 100% 100%;
  width: 447px;
}

.text_50 {
  width: 257px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 15px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 15px;
  margin: 8px 0 0 11px;
}

.image_11 {
  width: 447px;
  height: 251px;
}

body * {
  box-sizing: border-box;
  flex-shrink: 0;
}

body {
  font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
  Arial, PingFang SC-Light, Microsoft YaHei;
}

input {
  background-color: transparent;
  border: 0;
}

button {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
}

button:active {
  opacity: 0.6;
}

.van-nav-bar__left:active,
.van-nav-bar__right:active {
  opacity: 1;
}

[class*="van-"]::after {
  border-bottom: 0;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.flex-col999 {
  display: flex;

  flex-direction: column;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.video-title {
  color: #00FFF6; /* 复用主题色 */
  font-size: 14px;
  margin-bottom: 8px; /* 文字与视频的间距 */
  font-weight: 500;
}


.video-wrappercenter {
  display: flex;
  flex-direction: column;
  align-items: center; /* 文字和视频居中对齐 */
  margin-bottom: 10px; /* 调整间距 */
}

.video-wrapperleft {
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* 文字和视频居中对齐 */
  margin-bottom: 10px; /* 调整间距 */
}

.video-wrapperright {
  display: flex;
  flex-direction: column;
  align-items: flex-end; /* 文字和视频居中对齐 */
  margin-bottom: 10px; /* 调整间距 */
}

.justify-start {
  display: flex;
  justify-content: flex-start;
}

.justify-center {
  display: flex;
  justify-content: center;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}

.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}

.justify-around {
  display: flex;
  justify-content: space-around;
}

.justify-between {
  display: flex;
  justify-content: space-between;
}

.align-start {
  display: flex;
  align-items: flex-start;
}

.align-center {
  display: flex;
  align-items: center;
}

.align-end {
  display: flex;
  align-items: flex-end;
}

.topContentimg {
  height: 516px;
  object-fit: contain;
  // margin-top: -70px;
}

.svg-wrapper {
  margin-top: 23px;
  width: 100%;
  height: 100%;
  overflow: auto; /* 允许滚动查看超出部分 */
  cursor: grab; /* 使用"抓取"光标提示可交互 */
  position: relative;
  user-select: none; /* 防止拖动时选中文本 */
}

.svg-wrapper:active {
  cursor: grabbing; /* 点击时改变光标 */
}

.svg-container {
  width: 100%;
  height: 516px;
  display: inline-block; /* 重要：保持原始大小，然后应用缩放 */
  position: relative;
  transform: translateZ(0); /* 启用GPU加速 */
}

#drawing-area {
  display: block;
}

.shine-point {
  animation: shine-fade 1s ease-out forwards;
  will-change: opacity; /* 提示浏览器这个属性会变化 */
  pointer-events: none;
}

.dialog-content {
  color: #666;
  line-height: 1.6;
}

@keyframes shine-fade {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.illegal-parking-block {
  position: absolute;
  border-radius: 2px; /* 轻微圆角 */
  box-shadow: 0 0 5px rgba(213, 32, 25, 0.5); /* 添加阴影效果 */
  z-index: 10; /* 确保显示在最上层 */
  transform: translateZ(0); /* 启用GPU加速 */
}
</style>
